/**
 * Created by mauget on 3/13/16.
 */
// RestService.js

import $ from 'jquery';
import _ from 'lodash';
import Spinner              from 'spin/spin';
import constants            from 'Constants';
import listService          from 'ListService';
import XJService            from 'xml/XJService';
import restMessages         from 'RestMessages';
import guidUtil             from 'util/GuidUtil';
import utils                from 'util/Util';
import zLib                 from 'util/ZLib';
import configService        from 'ConfigService';
import userService          from 'UserService.js';
import md5                  from 'md5';
import restServiceAux       from 'RestServiceAux';
import {View, Model}        from 'backbone';
import PlayFormModal        from 'common-views/PlayFormModal.js';
import textUtil             from 'util/TextUtil';
import undoService          from 'UndoService';
import formulaService       from 'xml/FormulaService';
import xjService    from 'xml/XJService';
import mobileListService from "./mobile/MobileListService";
import eventBus  from 'EventBus';

//=============================================================================================================
// REST request and response processing carried out here.
//=============================================================================================================

class RestService {

    constructor() {

        configService.promise.then(config => {
            this.apiHostUrl = config.apiHostUrl;
            this.hostUrl = config.hostUrl;
        });
    }

    getLinkUrl(linkId) {
        // in the end we are forwarded to this type of URL
        // http://devel.perfectforms.com/PresentationServer/App.aspx/Play/7CRgAgYF?f=7CRgAgYF

        let id = linkId || listService.formBase.linkId;        
        return this.hostUrl + '/PresentationServer/App.aspx/Play/' + id + '?f=' + id;
    }

    getViewReportLinkUrl(linkId) {
        // in the end we are forwarded to this type of URL
        // http://devel.perfectforms.com/PresentationServer/App.aspx/Play/7CRgAgYF?f=7CRgAgYF
        let id = linkId || listService.formBase.linkId;
        return this.hostUrl + '/PresentationServer/App.aspx/Play/' + id + '?f=' + id +'&viewReport=true' + listService.isSSO();
    }

    getMultipleViewParam(reflowEnabled){
        let mv = 'd'; //Desktop view is the default
        let mo = '';
        if ((listService.mainKind === constants.KIND_MOBILE) || (reflowEnabled || (listService.currentForm && utils.isTrue(listService.currentForm.model.get('reflowEnabled'))))) {
            mv = 'phone';
            mo = 'portrait';
            if (mobileListService.mobileCurrentColumnView === constants.TWO_COLUMN_VIEW_DROPDOWN_TEXT) {
                mo = 'landscape'
            }

        }

        return `mv=${mv}&mo=${mo}`;
    }

    getPreviewLink() {
        //http://devel.perfectforms.com/PresentationServer/App.aspx/Preview/19241?t=-6347802308638801920&wfs=null&wfr=all

        return this.hostUrl + '/PresentationServer/App.aspx/Preview/' + listService.formBase.id + '?t=' + this.token + "&viewForm=true" + listService.isSSO() + '&wfs=' + listService.getWorkflowInitialStage() + '&wfr=' + listService.getCurrentRole() + '&' + this. getMultipleViewParam();
    }

    getMobilePreviewLink(device, orientation) {
        return this.hostUrl + '/PresentationServer/App.aspx/Preview/' + 
                listService.formBase.id + '?t=' + this.token + 
                '&mv=' + device + 
                '&mo=' + orientation;
    }

    getNewInstanceDraftLink(reflowEnabled) {
        return this.hostUrl + '/PresentationServer/App.aspx/Preview/{0}?wfs=' + listService.getCurrentStage() + '&wfr=' + listService.getCurrentRole() + '&' + this.getMultipleViewParam(reflowEnabled);
    }

    getDebugLink() {
        return this.hostUrl + '/PresentationServer/App.aspx/Preview/' + listService.formBase.id + '?t=' + this.token + '&wfs=' + listService.getWorkflowInitialStage() + '&wfr=' + listService.getCurrentRole() +'&debug=true' + '&' + this. getMultipleViewParam();
    }

    getAssetURL(assetId) {
        return this.apiHostUrl + '/assets?assetId=' + assetId + '&fileName=&fileMode=0';
    }

    setToken(tokenVal) {

        //This is used for tracing purposes, uncomment when needed
        //if (!tokenVal || typeof tokenVal === 'undefined') {
                // console.log("Setting an undefined session token ", tokenVal);
                // console.trace("Undefined session token");
        //}

        window.sessionStorage.setItem("loginToken", tokenVal);
    }

    getToken() {
        return window.sessionStorage.getItem("loginToken");
    }

    setEmail(emailVal) {
        window.sessionStorage.setItem("loginEmail", emailVal);
    }

    getEmail() {
        return window.sessionStorage.getItem("loginEmail");
    }

    setSelectedFormInEditFormDashboard(formId){
        window.sessionStorage.setItem('formIdEditFormDashboard',formId);
    }

    getSelectedFormInEditFormDashboard(){
        return window.sessionStorage.getItem('formIdEditFormDashboard');
    }

    getProfile() {
        return JSON.parse(window.localStorage.getItem('profile'));
    }

    setProfile({UserId, FirstName, LastName, EmailAddress, AccountId, AccountName = '', MaxAttachmentSize, LoginToken, ExpiryDate, CreatedDate, UpgradeButton, HtmlDashboardEnabled, Status, HomeReport, IsTrial,Token}) {
        return window.localStorage.setItem('profile', JSON.stringify({
            UserId,
            FirstName,
            LastName,
            EmailAddress,
            AccountId,
            AccountName,
            MaxAttachmentSize, // PF-1963
            LoginToken,
            ExpiryDate,
            CreatedDate,
            UpgradeButton,
            HtmlDashboardEnabled,
            Status,
            HomeReport,
            IsTrial,
            Token
        }));
    }

    /*
     setUser(user){
     window.localStorage.setItem("user", JSON.stringify(user));
     }

     getUser(){
     return JSON.parse(window.localStorage.getItem("loginToken"));
     }
     */

    set token(token) {
        this.setToken(token);
    }

    get token() {
        return this.getToken();
    }

    set user(user) {
        this.setUser(user);
    }

    get user() {
        return this.getToken();
    }

    //================================================================================================
    // Common settings for making a Jquery AJAX call. Can be overwritten by sending custom options.
    //================================================================================================
    getSettings(options = {}) {
        const defaults = {
            'async': true,
            'crossDomain': true,
            'url': this.apiHostUrl,
            'method': 'GET',
            'headers': {
                'cache-control': 'no-cache'
            },
            'processData': false,
            'contentType': 'multipart/form-data'
            //'data': {}
        };

        return Object.assign({}, defaults, options);
    }


    getFormFields(formId, formGUID, callback) {
        const postParams = {
            token: this.getToken(),
            formId: formId,
            formGUID: formGUID,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Report/BrowseFields';
        let self = this;
        $.post(url, postParams).done((response) => {

            const error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE'),
                newToken = _.get(response, 'RESULT.TOKEN'),
                fields = _.get(serverResponse, 'Fields.Field');

            if (parseInt(errorCode) === 0 && serverResponse) {
                this.setToken(newToken);
                callback(false, fields);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                callback(error);
            }


        }).fail(function () {
            callback('failed', arguments);
        });

    }


    // ==============================================================================
    // Rest API addAsset delegates to RestServiceAux
    // =============================================================================
    addAsset(file, formId, newAsset, imgData, callback) {
        restServiceAux.addAsset( file, formId, newAsset, imgData, callback );
    }

    importFormStyle(formId, name, file) {
        var result = {};
        var form = new FormData();
        form.append('token', this.getToken());
        form.append('name', name);
        form.append('type', 'form');
        form.append('Files', file);
        form.append('id', formId);

        var settings = {
            'async': true,
            'crossDomain': false,
            'url': this.apiHostUrl + '/Common/Import',
            'method': 'POST',
            "headers": {
                'cache-control': 'no-cache'
            },
            'processData': false,
            'contentType': false,
            'mimeType': 'multipart/form-data',
            'data': form,
            dataType: "JSON"
        };
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
        return promise;
    }

    importReportStyle(ReportId, name, file) {
        var result = {};
        var form = new FormData();
        form.append('token', this.getToken());
        form.append('name', name);
        form.append('type', 'reportversion');
        form.append('Files', file);
        form.append('id', ReportId);

        var settings = {
            'async': true,
            'crossDomain': false,
            'url': this.apiHostUrl + '/Common/Import',
            'method': 'POST',
            "headers": {
                'cache-control': 'no-cache'
            },
            'processData': false,
            'contentType': false,
            'mimeType': 'multipart/form-data',
            'data': form,
            dataType: "JSON"
        };
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
        return promise;
    }

    /*======================================================================
     * Rest API call for importing files
     * ======================================================================
     * */
    importFile(name, file, id = constants.DEFAULT_GROUP_ID, type = 'form', importOver = false) {
        var result = {};

        var form = new FormData();
        form.append('token', this.getToken());
        form.append('name', name);
        form.append('type', type);
        form.append('Files', file);
        form.append('id', id);
        form.append('importOver', importOver);
        
        var settings = {
            'async': true,
            'crossDomain': false,
            'url': this.apiHostUrl + '/Common/Import',
            'method': 'POST',
            "headers": {
                'cache-control': 'no-cache'
            },
            'processData': false,
            'contentType': false,
            'mimeType': 'multipart/form-data',
            'data': form,
            dataType: "JSON"
        };
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (response) {
                console.log('Imported File', response);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                console.log(error);
                console.log(errorCode);
                console.log(serverResponse);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(response);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
        return promise;
    }

    deleteAsset(assetId, callback) {
        var result = {};

        var form = new FormData();
        form.append("token", this.getToken());
        form.append("assetId", assetId);

        var settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + "/Assets/Delete",
            "method": "DELETE",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": form
        };

        let self = this;

        $.ajax(settings).done(function (data) {

            var response = JSON.parse(data);

            var error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse) {
                callback({assetId: assetId});
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                callback(error);
            }

        }).fail(function (jqXHR, textStatus, errorThrown) {
            callback('failed');
        });

    }


    /*======================================================================
     * Rest API call for retrieving published forms of the logged account.
     * ======================================================================
     * */
    getPublishedForms() {
        const postParams = {
            token: this.getToken(),
            groupId: constants.DEFAULT_GROUP_ID,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/App/BrowseViewable';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
        return promise;
    }

    /*======================================================================
     * Rest API call for password reset.
     * ======================================================================
     * */
    sendForgottenPassword(email,validMinutes=60) {
        const postParams = {
            email:email,
            validMinutes:validMinutes,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Login/SendForgottenPassword';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

        return promise;

    }

     /*======================================================================
     * Rest API call for search a form by its name.
     * ======================================================================
     * */
    searchFormByName(nameFilter, showSpinner = null) {
        const postParams = {
            'token':this.getToken(),
            nameFilter
        };
        const url = this.apiHostUrl + '/App/FormsFilterByName';
        let spinner;
        if (showSpinner){
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        }

        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                if (showSpinner){
                    spinner.stop();
                }
            });
        });

        return promise;

    }

     /*======================================================================
     * Rest API call for search a report by its name.
     * ======================================================================
     * */
    searchReportByName(nameFilter, showSpinner = null) {
        const postParams = {
            'token':this.getToken(),
            nameFilter
        };
        const url = this.apiHostUrl + '/Report/ReportsFilterByName';
        let spinner;
        if (showSpinner){
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        }

        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                if (showSpinner){
                    spinner.stop();
                }
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for updating the details of a form.
     * ======================================================================
     * */
    updateForm(formId, name, isActive, mobileEnabled, currentNotificationRequiresLogin, currentPermissionsToSend) {
        const postParams = {
            token: this.getToken(),
            formId: formId,
            dataType: 'JSON',
            name: name,
            isActive: isActive,
            mobileEnabled: mobileEnabled,
            notificationRequiresLogin: currentNotificationRequiresLogin,
            permissionsXML: currentPermissionsToSend
        };

        console.log("These are the post params Forms", postParams);
        const url = this.apiHostUrl + '/App/Update',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for updating the details of a report.
     * ======================================================================
     * */

    updateReport(reportId,name,isActive,permissionsToSend) {
        console.log('in rest service', arguments);

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("reportId", reportId);
        formData.append('name',name);
        formData.append('isActive',isActive);
        formData.append('permissionsXML',permissionsToSend);

        console.log(`updateReport permissionsXML: `, permissionsToSend);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Report/Update',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };
        console.log(`updateReport HTTP form data: `, formData);

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);
                console.log(`updateReport response data`, data);
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                    self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    console.log('updateReport', 'resolving promise');
                    console.log(errorCode, serverResponse);
                    resolve(response);
                } else {
                    console.log('updateReport', 'rejecting promise');
                    console.log(errorCode, serverResponse);
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for retrieving published forms of the logged account.
     * ======================================================================
     * */
    getPublishedReports(groupId) {
        const postParams = {
            token: this.getToken(),
            groupId: groupId || constants.DEFAULT_GROUP_ID,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Report/BrowseViewable';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for retrieving published forms of the logged account.
     * ======================================================================
     * */
    getReportFields(formGUID) {
        const postParams = {
            token: this.getToken(),
            formId: constants.DEFAULT_GROUP_ID,
            formGUID: formGUID,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Report/BrowseFields';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for retrieving opened viewable instances.
     * ======================================================================
     * */
    getViewableInstances(formId, isClosed, isArchived) {
        const postParams = {
            token: this.getToken(),
            formId: formId,
            dataType: 'JSON',
            isClosed: isClosed,
            isArchived: isArchived
        };
        let url = this.apiHostUrl + '/App/BrowseViewableInstances';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for retrieving opened viewable instances.
     * ======================================================================
     * */
    searchFormInstances(searchFormInstancesObject) {
        let defaultParams = {
            token: this.getToken(),
            status:-1,
            dataType: 'JSON',
            name:'',
            attentionLevel:-1,
            attentionLevelOrHigher:false,
            version:0,
            maxRecords:101,
            sortBy:'',
            archived:0,
            formsXML:'',
            firstSubmissionFrom:constants.DEFAULT_GROUP_ID,
            firstSubmissionTo:constants.DEFAULT_GROUP_ID,
            lastSubmissionForm:constants.DEFAULT_GROUP_ID,
            lastSubmissionTo:constants.DEFAULT_GROUP_ID
        };
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let postParams=Object.assign({},defaultParams,searchFormInstancesObject);
        postParams.maxRecords = parseInt(postParams.maxRecords);
        let url = this.apiHostUrl + '/App/SearchFormInstances';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for archive instances.
     * ======================================================================
     * */
    archiveInstances(formInstancesXML,type) {
        let postParams = {
            token: this.getToken(),
            formInstancesXML:formInstancesXML,
            dataType: 'JSON',
            type:type
        };
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let url = this.apiHostUrl + '/App/ArchiveInstances';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for retrieving form instances based on search parameters.
     * ======================================================================
     * */
    searchViewableFormInstanceDetails(formId,
                                      instanceName = '%',
                                      status = "-1",
                                      myAttentionLevel = "-1",
                                      attentionLevelOrHigher = "false",
                                      otherAttentionLevel = "-1",
                                      otherAttentionLevelOrHigher = "false") {
        const postParams = {
            token: this.getToken(),
            formId: formId,
            dataType: 'JSON',
            status: status,
            myAttentionLevel: myAttentionLevel,
            myAttentionLevelOrHigher: attentionLevelOrHigher,
            otherAttentionLevel: otherAttentionLevel,
            otherAttentionLevelOrHigher: otherAttentionLevelOrHigher,
            instanceName: instanceName,
            version: '0',
            startIndex: '1',
            maxRecords: '100',
            sortBy: ''
        };
        let url = this.apiHostUrl + '/App/SearchViewableFormInstances';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

        return promise;

    }


    /*==============================================================================
     * Rest API call for retrieving details of a form
     * =============================================================================
     * */
    getFormDetails(formId) {

        let formsRequestObject = {
            url: this.apiHostUrl + '/App/Details?token=' + this.getToken() + '&formId=' + formId,
            method: 'GET'
        };
        let settings = this.getSettings(formsRequestObject);
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                //var response = JSON.parse(data);
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);                   
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

                self.setToken(response.RESULT.TOKEN);

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving details of a report
     * =============================================================================
     * */
    getReportDetails(reportId) {
        const postParams = {
            token: this.getToken(),
            reportId: reportId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Report/GetDetails',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*======================================================================
     * Rest API call for retrieving Dashboard Details Data.
     * ======================================================================
     * */
    getDashboardDetails(dashboardParams) {
        return restServiceAux.getDashboardDetails(dashboardParams);
    }

    /*==============================================================================
     * Rest API call for retrieving details of a Connection.
     * =============================================================================
     * */
    getConnectionDetails(connectionId) {
        const getParams = {
            token: this.getToken(),
            connectionId: connectionId,
            dataType: 'JSON',
            purpose: 0,
            formId: constants.DEFAULT_GROUP_ID
        };
        const url = this.apiHostUrl + '/Integration/GetConnection',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.get(url, getParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for delete a Connection.
     * =============================================================================
     * */
    deleteConnection(connectionId) {
        const postParams = {
            token: this.getToken(),
            connectionId: connectionId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/DeleteConnection',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }


    /*==============================================================================
     * Rest API call for delete a Connection.
     * =============================================================================
     * */
    undeleteConnection(connectionId) {
        const postParams = {
            token: this.getToken(),
            connectionId: connectionId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/UndeleteConnection',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }


//
    /*==============================================================================
     * Rest API call for delete an Action.
     * =============================================================================
     * */
    deleteAction(actionId,connectionId) {
        const postParams = {
            token: this.getToken(),
            actionId: actionId,
            connectionId: connectionId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/DeleteAction',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }


       /*==============================================================================
     * Rest API call for delete an Action.
     * =============================================================================
     * */
    undeleteAction(connectionId, actionId) {
        const postParams = {
            token: this.getToken(),
            actionId: actionId,
            connectionId: connectionId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/UndeleteAction',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for adding a new action to a connection.
     * =============================================================================
     * */
    addAction(connectionId, actionType, actionXML) {
        const defaultParameters = {
            token: this.getToken(),
            connectionId: connectionId,
            name: 'New Action',
            type: actionType,
            actionXML: actionXML,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/NewAction',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                                    
                self.setToken(response.RESULT.TOKEN);    

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for retrieving details of a Email Server
     * =============================================================================
     * */
    getEmailServerDetails(emailServerId) {
        const postParams = {
            token: this.getToken(),
            emailServerId: emailServerId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Account/GetEmailServerDetails',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for adding a new Email Server.
     * =============================================================================
     * */
    addEmailServer() {
        const defaultParameters = constants.BASIC_EMAIL_SERVER_DEFAULTS;
        defaultParameters.token = this.getToken();
         
        const url = this.apiHostUrl + '/Account/AddEmailServer',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for adding a new Connection.
     * =============================================================================
     * */
    addConnection(connectionType) {
        let addNewXML = `<Connection id="" name="New Connection" type="${connectionType}" active="true" timeout="60" useProxy="false" formId="" formGUID="" formName=""/>`;
        let compressedXML = zLib.compressForm(addNewXML);
        const defaultParameters = {
            token: this.getToken(),
            name: 'New Connection',
            type: connectionType,
            connectionXML: compressedXML,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Integration/NewConnection',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                    self.setToken(response.RESULT.TOKEN);
                    
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for adding a new Connection.
     * =============================================================================
     * */
    sendPasswordLink(userId,validMinutes=1440) {
        const defaultParameters = {
            token:this.getToken(),
            userId,
            validMinutes,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/User/SendTemporaryUserPassword',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    sendAPIKey(userId) {
        const defaultParameters = {
            token:this.getToken(),
            userId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/User/SendUserAPIKey',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for adding a new Custom list.
     * =============================================================================
     * */
    addCustomList() {
        const defaultParameters = {
            token: this.getToken(),
            name: 'My List',
            customListXML: '&lt;CustomList&gt;&lt;Item caption="A" value="1"/&gt;&lt;/CustomList&gt;',
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Account/AddCustomList',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*======================================================================
     * Rest API call for updating account settings
     * ======================================================================
     * */
    updateAccount(accountParams) {
        const defaultParams = {
            token: this.getToken(),
            dataType: 'JSON'
        };

        const paramsToSend = Object.assign({}, defaultParams, accountParams);
        console.log('params to Send', paramsToSend);
        let url = this.apiHostUrl + '/Account/AccountUpdate',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, paramsToSend).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);

                    window.localStorage.setItem('DirectoryServiceEnabled',paramsToSend.directoryServiceEnabled);
                    window.localStorage.setItem('checkSingleSignOn',false);
                    window.localStorage.setItem('DirectoryServiceGatewayURL', paramsToSend.directoryServiceGatewayURL);

                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call to update a REST/SOAP WSSource
     * ======================================================================
     * */
    updateWSSource(wsSourceId, wsSource) {
        const defaultParameters = {
            token:this.getToken(),
            wsSourceId,
            wsSource: wsSource.trim()
        };
        console.log('params to Send', defaultParameters);
        let url = this.apiHostUrl + '/Account/WSSourceUpdate',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call to delete a REST/SOAP WSSource
     * ======================================================================
     * */
    deleteWSSource(wsSourceId) {
        const defaultParameters = {
            token:this.getToken(),
            wsSourceId
        };
        console.log('params to Send', defaultParameters);
        let url = this.apiHostUrl + '/Account/WSSourceDelete',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call to create a REST/SOAP WSSource
     * ======================================================================
     * */
    createWSSource(wsSource) {
        const defaultParameters = {
            token:this.getToken(),
            wsSource
        };
        console.log('params to Send', defaultParameters);
        let url = this.apiHostUrl + '/Account/WSSourceCreate',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*==============================================================================
     * Rest API call for retrieving url sources for REST and SOAP
     * =============================================================================
     * */
    getWSSources() {
        const postParams = {
            token: this.getToken(),
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Account/WSSourcesGet',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    console.log('WSSourcesGet response', response);
                    resolve(response.RESULT.RESPONSE);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                    self.setToken(response.RESULT.TOKEN);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /* ==============================================================================
    * Rest API call to get the list of SOAP and REST connections associated with a WSSource
    * =============================================================================
    * */
    getWSSourceConnections(wsSourceId) {
        const defaultParameters = {
            token:this.getToken(),
            wsSourceId,
            dataType: 'JSON'
        };
        console.log('params to Send', defaultParameters);
        const url = this.apiHostUrl + '/Integration/WSSourceConnectionsGet',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    self.setToken(response.RESULT.TOKEN);
                    let connections = response.RESULT.RESPONSE.ConnectionList ? response.RESULT.RESPONSE.ConnectionList.Connection : [];
                    console.log('Current Connections', connections);
                    self.setToken(response.RESULT.TOKEN);
                    
                    if (connections instanceof Array) {
                        resolve(connections);
                    }
                    else {
                        resolve([connections])                        
                    }
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                    
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*======================================================================
     * Rest API call for updating account settings
     * ======================================================================
     * */
    updateEmailServerDetails(emailServerParams) {
        const defaultParams = {
            token: this.getToken(),
            dataType: 'JSON'
        };

        const paramsToSend = Object.assign({}, defaultParams, emailServerParams);
        console.log('params to Send', paramsToSend);
        let url = this.apiHostUrl + '/Account/UpdateEmailServerDetails',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, paramsToSend).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call to send Trial Expired Request
     * ======================================================================
     * */
    sendTrialExtensionRequest(email, token) {
        const defaultParameters = {
            email:email,
            token:token,
            dataType: 'JSON'
        };
    
        const url = this.apiHostUrl + '/Account/TrialExtensionRequest',
        spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    
    }

    /*======================================================================
     * Rest API call for updating connection details.
     * ======================================================================
     * */
    updateConnection(connectionDetailsObject) {

        let formData = new FormData();
        // Required Values for this API Call

        formData.append('token', this.getToken());

        $.each(connectionDetailsObject, function (property, value) {
            formData.append(utils.firstToLowerCase(property), value || '');
        });

        let params = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/UpdateConnection',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };
        let settings = this.getSettings(params);
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        console.log('Settings', settings);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                    self.setToken(response.RESULT.TOKEN);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*======================================================================
     * PF-11040 Rest API call for updating connection xml.
     * ======================================================================
     * */
    updateConnectionServiceURL(connectionDetailsObject) {

        let formData = new FormData();
        // Required Values for this API Call

        formData.append('token', this.getToken());

        $.each(connectionDetailsObject, function (property, value) {
            formData.append(utils.firstToLowerCase(property), value || '');
        });

        let params = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/UpdateConnectionServiceURL',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };
        let settings = this.getSettings(params);
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        console.log('Settings', settings);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                    self.setToken(response.RESULT.TOKEN);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*======================================================================
     * Rest API call for updating action details.
     * ======================================================================
     * */
    updateAction(connectionDetailsObject) {

        let formData = new FormData();
        // Required Values for this API Call

        formData.append('token', this.getToken());

        $.each(connectionDetailsObject, function (property, value) {
            formData.append(utils.firstToLowerCase(property), value || '');
        });

        let params = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/UpdateAction',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };
        let settings = this.getSettings(params);
        let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        console.log('Settings', settings);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*======================================================================
     * Rest API call for setting the default update email server
     * ======================================================================
     * */
    setAccountDefaultEmailServer(emailServerId = constants.DEFAULT_GROUP_ID) {
        const paramsToSend = {
            token: this.getToken(),
            dataType: 'JSON',
            emailServerId: emailServerId
        };


        let url = this.apiHostUrl + '/Account/SetAccountDefaultEmailServer',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, paramsToSend).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    reject(error);
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for test an email server
     * ======================================================================
     * */
    testEmailServer(emailServerId, recipient, subject) {
        const paramsToSend = {
            token: this.getToken(),
            dataType: 'JSON',
            emailServerId: emailServerId,
            recipient: recipient,
            subject: subject
        };


        let url = this.apiHostUrl + '/Account/TestEmailServer',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, paramsToSend).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                console.log("Params to send", response);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    self.setToken(response.RESULT.TOKEN);
                    resolve(response);
                }
                else if (parseInt(errorCode) === 31) {
                    self.setToken(response.RESULT.TOKEN);
                    reject(error);
                }
                else {
                    if (response.RESULT.TOKEN){
                        self.setToken(response.RESULT.TOKEN);
                    }
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

     /*======================================================================
     * Rest API call to get all of the email send providers with OAuth
     * ======================================================================
     * */
    getEmailSendProviders() {
      
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'GET',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/Account/GetEmailSendProviders',
                data: {token: this.getToken()},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse.EmailSendProviderList.EmailSendProvider || 'Email server providers obtained');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }


     /*======================================================================
     * Rest API call to return the URL to invoke the authorization process 
       for Microsoft 365 Exchange Online OAuth 2.0.
     * ======================================================================
     * */
     getOAuthAuthorizationURL(oAuthProviderId) {
   
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'GET',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/AuthenticationProvider/GetOAuthAuthorizationURI',
                data: {token: this.getToken(), oAuthProviderId: oAuthProviderId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'URL Returned');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    /*======================================================================
     * Rest API call to validate the Code obtained after the user 
        is authenticated through the Authentication Provider.
     * ======================================================================
     * */
    validateOAuthCode(oAuthProviderId, emailServerId, code) {
   
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/AuthenticationProvider/ValidateOAuthCode',
                data: {
                        token: this.getToken(), 
                        oAuthProviderId: oAuthProviderId, 
                        emailServerId: emailServerId,
                        code: code
                      },
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                        self.setToken(token);
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'User Authenticated');
                    } else if (parseInt(errorCode) === 170 || parseInt(errorCode) === 171 || parseInt(errorCode) === 172 ) {
                        self.setToken(response.RESULT.TOKEN);
                        reject(`${restMessages.codeToMessage(errorCode)}`);
                    }else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

     /*======================================================================
     * Rest API call to validate the Code obtained after the user 
        is authenticated through the Authentication Provider for Google Sheets
     * ======================================================================
     * */
        GoogleValidateOAuthCode(code) {
   
            return new Promise((resolve, reject) => {
                let self = this;
                $.ajax({
                    type: 'POST',
                    async: true,
                    headers: {
                        "cache-control": "no-cache"
                    },
                    url: this.apiHostUrl + '/integration/GoogleValidateOAuthCode',
                    data: {
                            token: this.getToken(),
                            code: code
                          },
                    success: function (data) {
                        // successful request; do something with the data
                        var response = data;
                        var error = _.get(response, 'RESULT.ERROR'),
                            errorCode = _.get(error, 'CODE'),
                            errorMessage = _.get(error, 'MESSAGE'),
                            serverResponse = _.get(response, 'RESULT.RESPONSE'),
                            token = _.get(response, 'RESULT.TOKEN');
                            self.setToken(token);
                        if (parseInt(errorCode) === 0) {
                            resolve(serverResponse || 'User Authenticated');
                        } else if (parseInt(errorCode) === 170 || parseInt(errorCode) === 171 || parseInt(errorCode) === 172 ) {
                            self.setToken(response.RESULT.TOKEN);
                            reject(`${restMessages.codeToMessage(errorCode)}`);
                        }else {
                            self.checkErrorCodeUserNotAuthenticated(errorCode);
                            reject(error);
                        }
                    },
                    error: function (error) {
                        reject(error);
                    }
                });
            });
        }

    /*======================================================================
     * Rest API call to validate the oAuth Credential
     * ======================================================================
     * */
    validateOAuthCredential(oAuthCredentialId) {

        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/AuthenticationProvider/ValidateOAuthCredential',
                data: {
                    token: this.getToken(),
                    oAuthCredentialId: oAuthCredentialId
                },
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'User Authenticated');
                        self.setToken(token);
                    }else if (parseInt(errorCode) === 170 || parseInt(errorCode) === 171 || parseInt(errorCode) === 172 ) {
                        self.setToken(response.RESULT.TOKEN);
                        reject(`${restMessages.codeToMessage(errorCode)}`);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

     /*======================================================================
     * Rest API call to validate the oAuth Credential
     * ======================================================================
     * */
     GoogleValidateOAuthCredential(params) {
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
            let self = this;
            const url = this.apiHostUrl + '/integration/GoogleValidateOAuthCredential';
            const paramsToSend = {
                token: this.getToken(),
                access_token: params.accessToken,
                refresh_token: params.refreshToken
            };

            $.post(url, paramsToSend).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'User Authenticated');
                        self.setToken(token);
                    }else if (parseInt(errorCode) === 170 || parseInt(errorCode) === 171 || parseInt(errorCode) === 172 ) {
                        self.setToken(response.RESULT.TOKEN);
                        reject(`${restMessages.codeToMessage(errorCode)}`);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }



    /*======================================================================
     * Rest API call for retrieving private forms of the logged account.
     * ======================================================================
     * */
    getFormsByGroupType(groupTypeId, groupId = constants.DEFAULT_GROUP_ID) {
        return restServiceAux.getFormsByGroupType(groupTypeId, groupId);
    }

    /*======================================================================
     * Rest API call tp get all apps
     * ======================================================================
     * */
    getAllApps(){
        const postParams = {
            token: restService.token,
            dataType: 'JSON'
        };

        const url = `${restService.apiHostUrl}/App/GetAllListSummary`;
        let self = this;

        return new Promise((resolve, reject) => {
            $.get(url, postParams).done(function (data) {
                const response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse) {
                    self.setToken( response.RESULT.TOKEN );
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*======================================================================
     * Rest API call to get all reports
     * ======================================================================
     * */
    getAllReports(){
        const postParams = {
            token: restService.token,
            dataType: 'JSON'
        };

        const url = `${restService.apiHostUrl}/report/GetAllListSummary`;
        let self = this;

        return new Promise((resolve, reject) => {
            $.get(url, postParams).done(function (data) {
                const response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse) {
                    self.setToken( response.RESULT.TOKEN );
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }



    /*======================================================================
     * Rest API call for getting published forms not including instances.
     * ======================================================================
     * */
    getBrowseFormsForReporting(groupTypeId, groupId = constants.DEFAULT_GROUP_ID) {
        const postParams = {
            token: this.getToken(),
            groupTypeId: groupTypeId,
            groupId: groupId,
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/Report/BrowseFormsForReporting';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    /*==============================================================================
     * Rest API call for deleting a form
     * =============================================================================
     * */
    deleteForm(formId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/App',
                data: {token: this.getToken(), formId: formId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0) {
                       
                        self.setToken(token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(serverResponse || 'App successfully deleted');
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    deleteMobileForm(formId, deleteVersion) {

        // 1 Current
        // 2 Previous versions

        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/App/DeleteMobile',
                data: {token: this.getToken(), formId: formId, deletionScope: deleteVersion},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    unDeleteMobileForm(formId){
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/App/UndeleteMobileForm',
                data: {token: this.getToken(), formId: formId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    unDeleteForm(formId){
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/App/UndeleteForm',
                data: {token: this.getToken(), formId: formId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        
                        self.setToken(token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(serverResponse || 'App successfully restored');
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    deleteFormPreviousVersions(formId){
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/App/FormReset',
                data: {token: this.getToken(), formId: formId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    addUser() {
        const defaultParameters = {
            token: this.getToken(),
            firstName: 'New',
            lastName: 'User',
            dataType: 'JSON'
        };
        const url = this.apiHostUrl + '/User/Add',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, defaultParameters).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    //Remove users cache
                    self._removeAllUsersCache();
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    deleteUser(userId) {
        return new Promise((resolve, reject) => {
            let self = this;
            console.log('=== DELETING USER ===', userId)
            $.ajax({
                type: 'DELETE',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/user/Delete',
                data: {token: this.getToken(), userId: userId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        //Remove users cache
                        self._removeAllUsersCache();
                        resolve(serverResponse || 'User successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    deletePosition(positionId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/user/DeletePosition',
                data: {token: this.getToken(), positionId: positionId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        //Remove users cache
                        self._removeAllUsersCache();
                        resolve(serverResponse || 'Position successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    unDeleteUser(userId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/user/UndeleteUser',
                data: {token: this.getToken(), userId: userId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'User successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    // PF-4931 added method:
    unBlockUser(userId) {

        const postParams = {
            token: this.getToken(),
            userId: userId
        };
        const url = `${this.apiHostUrl}/user/UnblockUser`;

        return new Promise( (resolve, reject) => {
            $.post(url, postParams).done( response => {
                const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    token = _.get(response, 'RESULT.TOKEN'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0) {
                    resolve(serverResponse);
                } else {
                    this.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                this.setToken(token);
            }).fail(  (jqXHR, textStatus, errorThrown) => {
                reject(errorThrown);
            });
        });
    }

    undeleteEmailServer(emailServerId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/account/undeleteEmailServer',
                data: {token: this.getToken(), emailServerId: emailServerId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'Email server successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    undeleteCustomList(customListId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/account/undeleteCustomList',
                data: {token: this.getToken(), customListId: customListId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'Email server successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    undeleteUserGroup(groupId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/user/UndeleteUserGroup',
                data: {token: this.getToken(), groupId: groupId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'Group successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    undeletePosition(positionId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/user/UndeletePosition',
                data: {token: this.getToken(), positionId: positionId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'Position successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    /*==============================================================================
     * Rest API call for deleting a report
     * =============================================================================
     * */
    deleteReport(reportId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/Report',
                data: {token: this.getToken(), reportId: reportId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        self.setToken(token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(serverResponse || 'Report successfully deleted');
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    unDeleteReport(reportId){
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/Report/Undelete',
                data: {token: this.getToken(), reportId: reportId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                       
                        self.setToken(token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(serverResponse || 'Report successfully restored');
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }


    /*==============================================================================
     * Rest API call for deleting draft instance of a form
     * =============================================================================
     * */
    deleteFormDraftInstances(formId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                url: this.apiHostUrl + '/App/DeleteDraftInstances',
                data: {token: this.getToken(), formId: formId},
                success: function (data) {
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App draft instances successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }


    /*==============================================================================
     * Rest API call for publishing a form and play it
     * =============================================================================
     * */
    createNewInstanceForm(formLink) {
        const postParams = {
            token: this.getToken(),
            linkId: formLink
        };
        const url = this.apiHostUrl + '/Play/App',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        let self = this;

        return new Promise((resolve, reject) => {

            $.post(url, postParams).done((response) => {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    newToken = _.get(response, 'RESULT.TOKEN'),
                    fields = _.get(serverResponse, 'Fields.Field');

                self.setToken(newToken);
                if (parseInt(errorCode) === 0 && serverResponse) {
                    resolve(serverResponse);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function () {
                reject(arguments);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    exportFormResponseData(formId, type, name) {
        /*  The 'name' parameter contains the name that should have the file that we are downloading
         At this point we don't have chance to changue it.
         1. An ajax call it is not gonna work to download the file, so we don't have the content of the file
         and we cannot use an URI component or a blob
         2. Using an iframe (even with a download attribute) won't changue the name of the file, since that
         dialog is based on OS, and we cant modify it from js  */
        let src = this.apiHostUrl + '/Common/Export?token=' + this.getToken() + '&id=' + formId + '&type=' + type;

        //File name can be defined, only applies for type 'fix' (Form instance data in XML format) and 'fic' (Form instance data in CSV format)
        if (type.toLowerCase() === 'fix' || type.toLowerCase() === 'fic'){
            src += '&fileName=' + name;
        }

        if(textUtil.isIExplorer()) {
            listService.isOnExport = true;
        }

        var iframe = document.createElement('iframe');
        iframe.id = "IFRAMEID";
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        iframe.src = src;
        iframe.download = name;
        iframe.addEventListener("load", function () {
            console.log("FILE LOAD DONE.. Download should start now");
        });
    }


    /*==============================================================================
     * Rest API call for publishing a report and play it
     * =============================================================================
     * */
    createNewInstanceReport(formLink) {
        const postParams = {
            token: this.getToken(),
            linkId: formLink
        };
        const url = this.apiHostUrl + '/Play/Report',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        let self = this;

        return new Promise((resolve, reject) => {

            $.post(url, postParams).done((response) => {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE'),
                    newToken = _.get(response, 'RESULT.TOKEN'),
                    fields = _.get(serverResponse, 'Fields.Field');

                self.setToken(newToken);
                if (parseInt(errorCode) === 0 && serverResponse) {
                    resolve(serverResponse);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function () {
                reject(arguments);
            }).always(() => {
                spinner.stop();
            });

        });
    }


    /*======================================================================
     * Rest API call for retrieving private forms of the logged account.
     * ======================================================================
     * */
    getReportsByGroupType(groupTypeId, groupId = constants.DEFAULT_GROUP_ID, reportId = constants.DEFAULT_REPORT_ID) {

        // let form = new FormData();
        // form.append('token', this.getToken());
        // form.append('reportId', reportId);
        // form.append('groupTypeId', groupTypeId);
        // form.append('groupId', groupId);


        const formsRequestObject = {
            // url: this.apiHostUrl + '/Report/Browse',
            // data: form,
            // method: 'POST'
            token: this.getToken(),
            reportId,
            groupTypeId,
            groupId
        };
        const url = this.apiHostUrl + '/Report/Browse';


        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, formsRequestObject).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    self.setToken(response.RESULT.TOKEN);
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    /*==============================================================================
     * Rest API call for retrieving reports that belong to the View Reports Folder.
     * =============================================================================
     */
    getViewReports(groupId = constants.DEFAULT_GROUP_ID) {

        let form = new FormData();
        form.append('token', this.getToken());
        form.append('groupId', groupId);


        let formsRequestObject = {
            url: this.apiHostUrl + '/Report/BrowseViewable',
            data: form,
            method: 'POST'
        };
        let settings = this.getSettings(formsRequestObject);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*======================================================================
     * Rest API call for retrieving library reports from the server
     * ======================================================================
     * */
    getLibraryForms(groupType, groupId = constants.DEFAULT_GROUP_ID) {
        let requestObject = {
            url: this.apiHostUrl + '/Admin/BrowseLibrary?token=' + this.getToken() + '&groupId=' + (groupId === '0' ? constants.DEFAULT_GROUP_ID : groupId) + '&type=' + groupType,
            method: 'GET'
        };
        let settings = this.getSettings(requestObject);
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    /*==============================================================================
     * Rest API call for Importing a Library
     * =============================================================================
     * */
    importLibrary(libraryId) {

        const postParams = {
            token: this.getToken(),
            libraryId: libraryId
        };
        const url = this.apiHostUrl + '/Library/ImportLibraryForm';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {

                console.log('Library App', data);
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    /*==============================================================================
     * Rest API call for retrieving details of an Open Instance.
     * =============================================================================
     * */
    getOpenInstanceViewDetails(formInstanceId) {

        let form = new FormData();
        form.append('token', this.getToken());
        form.append('formInstanceId', formInstanceId);


        let postParams = {
            token: this.getToken(),
            formInstanceId: formInstanceId
        };
        const url = this.apiHostUrl + '/App/GetInstanceDetails',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                spinner.stop();
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving all users
     * =============================================================================
     * */
    browseAllUsers() {

        const postParams = {
            token: this.getToken()
        };

        const url = this.apiHostUrl + '/User/BrowseAllUsers', 
        spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            const usersCacheStorageKey = constants.PREFIX_STORAGE_USERS_CACHE + listService.userProfile.UserId.replace('-', '');
            if (!window.sessionStorage.getItem(usersCacheStorageKey)){
                $.post(url, postParams).done(function (data) {
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE');
                    
                    self.setToken(response.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                        let responseStr = JSON.stringify(response.RESULT.RESPONSE);
                        if (responseStr.length > 2000000){
                            let compressedResponse =  zLib.compressForm(responseStr);
                            try {
                                window.sessionStorage.setItem(usersCacheStorageKey, compressedResponse);
                                }
                                catch(err) {
                                console.log('Window session storage error. ', err);
                                }                                
                        }
                        spinner.stop();
                        resolve(response.RESULT.RESPONSE);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        spinner.stop();
                        reject(error);
                    }                   
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    spinner.stop();
                    reject(errorThrown);
                });
            }else{
                let decompressedResponse = zLib.decompressForm(window.sessionStorage.getItem(usersCacheStorageKey));
                spinner.stop();
                resolve(JSON.parse(decompressedResponse));
            }
        });
    }

    /*==============================================================================
     * Rest API call for retrieving users.
     * =============================================================================
     * */
    browseUsers() {

        const postParams = {
            token: this.getToken()
        };

        const url = this.apiHostUrl + '/User/BrowseUsers';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving user groups
     * =============================================================================
     * */
    browseUserGroups() {

        const postParams = {
            token: this.getToken()
        };
        const url = this.apiHostUrl + '/User/BrowseUserGroups',
        spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop();
                console.log('UserGroupsAPI', data);
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for search users groups
     * =============================================================================
     * */
    searchUserGroups( groupName = '%' ) {
        const postParams = {
            token: this.getToken(),
            name: groupName,
            startIndex: '1',
            maxRecords: '50'
        };
        const url = this.apiHostUrl + '/User/SearchUserGroups';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                console.log('UserGroupsAPI', data);
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
    * Rest API call for hiding notifications
    * =============================================================================
    * */
    hideNotification(notificationsXML) {

        const postParams = {
            token: this.getToken(),
            notificationsXML:notificationsXML
        };
        const url = this.apiHostUrl + '/Notifications/Hide';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
    * Rest API call for hiding notifications
    * =============================================================================
    * */
    unhideNotification(notificationsXML) {

        const postParams = {
            token: this.getToken(),
            notificationsXML:notificationsXML
        };
        const url = this.apiHostUrl + '/App/UnhideNotifications';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for adding new user groups
     * =============================================================================
     * */
      addUserGroup(name = "New Group") {

        const postParams = {
          token: this.getToken(),
          name:name
        };
        const url = this.apiHostUrl + '/User/AddUserGroup';

        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function (data) {
            console.log('UserGroupsAPI', data);
            let response = data;
            let error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                //Remove users cache
                self._removeAllUsersCache();
                resolve(response.RESULT.RESPONSE);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }
            self.setToken(response.RESULT.TOKEN);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown);
          });
        });
      }

    _removeAllUsersCache(){
        const usersCacheStorageKey = constants.PREFIX_STORAGE_USERS_CACHE + listService.userProfile.UserId.replace('-', '');
        window.sessionStorage.removeItem(usersCacheStorageKey);
    }

    /*==============================================================================
     * Rest API call for adding new positions
     * =============================================================================
     * */
      addPosition(name = "New Position") {

        const postParams = {
          token: this.getToken(),
          name:name
        };
        const url = this.apiHostUrl + '/User/AddPosition';

        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function (data) {
            console.log('Add Position', data);
            let response = data;
            let error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              resolve(response.RESULT.RESPONSE);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }
            self.setToken(response.RESULT.TOKEN);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown);
          });
        });
      }

    /*==============================================================================
    * Rest API call for getting positions
    * =============================================================================
    * */
    searchPositions(name,
                    startIndex = '1',
                    maxRecords = '50',
                    sortBy = '') {

        const postParams = {token: this.getToken(),
                            name,
                            startIndex,
                            maxRecords,
                            sortBy};

        console.log('API Search', postParams);
        const url = this.apiHostUrl + '/User/SearchPositions',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop();
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for getting new position details
     * =============================================================================
     * */
      getUserPositionDetails(positionId) {

        const postParams = {
          token: this.getToken(),
          positionId
        };
        const url = this.apiHostUrl + '/User/PositionsDetails';
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function (data) {
            spinner.stop();
            console.log('Add Position', data);
            let response = data;
            let error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              resolve(response.RESULT.RESPONSE);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }
            self.setToken(response.RESULT.TOKEN);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            spinner.stop();
            reject(errorThrown);
          });
        });
      }


    /*==============================================================================
     * Rest API call for retrieving groups details.
     * =============================================================================
     * */
    getGroupDetails(groupId) {
        const postParams = {
            token: this.getToken(),
            groupId: groupId
        };
        const url = this.apiHostUrl + '/User/UserGroupDetails',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop()
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    self.setToken(response.RESULT.TOKEN);
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    deleteUserGroup(groupId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/User/DeleteUserGroup',
                data: {token: this.getToken(), groupId: groupId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        //Remove users cache
                        self._removeAllUsersCache();
                        resolve(serverResponse || 'User Group successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

      deleteUserPosition(userPositionId) {
        const postParams = {
          token: this.getToken(),
          positionId: userPositionId
        };
        const url = this.apiHostUrl + '/User/DeletePosition';

        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function (data) {
            var response = data;
            var error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              self.setToken(response.RESULT.TOKEN);
              resolve(response.RESULT.RESPONSE);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown);
          });
        });
      }

    /*==============================================================================
     * Rest API call for update group details.
     * =============================================================================
     * */
    updateUserGroup(group) {
        const postParams = {
            token: this.getToken(),
            groupId: group.groupId,
            name: group.name,
            description: group.description,
            isActive: group.isActive.toLowerCase() === 'true',
            members: group.members
        };
        const url = this.apiHostUrl + '/User/UpdateUserGroup';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    token = _.get(response, 'RESULT.TOKEN'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    //Remove users cache
                    self._removeAllUsersCache();
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(token);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for update group details.
     * =============================================================================
     * */
      updateUserPosition(position) {
        const postParams = {
          token: this.getToken(),
          positionId: position.positionId,
          name: position.name,
          description: position.description,
          isActive: position.isActive.toLowerCase() === 'true',
          members: position.members
        };
        const url = this.apiHostUrl + '/User/UpdatePosition';

        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function (data) {
            var response = data;
            var error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                token = _.get(response, 'RESULT.TOKEN'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');
            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                //Remove users cache
                self._removeAllUsersCache();
                resolve(response.RESULT.RESPONSE);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }
            self.setToken(token);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown);
          });
        });
      }


    /*==============================================================================
     * Rest API call for add one user to a group
     * =============================================================================
     * */
    addUserToUserGroup(userId, groupId) {
        const postParams = {
            token: this.getToken(),
            userId: userId,
            groupId: groupId
        };
        const url = this.apiHostUrl + '/User/AddUserToUserGroup';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    token = _.get(response, 'RESULT.TOKEN'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(token);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    /*==============================================================================
     * Rest API call for remove one user to a group
     * =============================================================================
     * */
    removeUserFromUserGroup(userId, groupId) {
        const postParams = {
            token: this.getToken(),
            userId: userId,
            groupId: groupId
        };
        const url = this.apiHostUrl + '/User/RemoveUserFromUserGroup';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    token = _.get(response, 'RESULT.TOKEN'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(token);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving positions
     * =============================================================================
     * */
    browsePositions() {

        const postParams = {
            token: this.getToken()
        };
        const url = this.apiHostUrl + '/User/BrowsePositions';
        
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {

                console.log('PositionsAPI', data);
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving details of an Library Item.
     * =============================================================================
     * */
    getLibraryDetails(libraryId) {
        let requestObject = {
            url: this.apiHostUrl + '/Admin/GetLibraryItemDetails?token=' + this.getToken() + '&libraryId=' + libraryId,
            method: 'GET'
        };
        let settings = this.getSettings(requestObject);
        
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                spinner.stop();
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving users
     * =============================================================================
     * */
    browseUsers() {

        const postParams = {
            token: this.getToken()
        };
        const url = this.apiHostUrl + '/User/BrowseUsers';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving user details.
     * =============================================================================
     * */
    getUserDetails(userId) {

        const postParams = {
            token: this.getToken(),
            userId: userId
        };
        const url = this.apiHostUrl + '/User/UserDetails',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop();
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for search users
     * =============================================================================
     * */
    searchUsers(status = '-1',
                firstName = '%',
                lastName = '%',
                emailAddress = '%',
                directoryServiceUserName = '%',
                customId = '%', startIndex = '1',
                maxRecords = '50',
                sortBy = '') {

        const postParams = {
            token: this.getToken(),
            status,
            firstName,
            lastName,
            emailAddress,
            directoryServiceUserName,
            customId,
            startIndex,
            maxRecords,
            sortBy
        };
        console.log('API Search', postParams);
        const url = this.apiHostUrl + '/User/SearchUsers';
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop();
                const response = data;
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for updating a user.
     * =============================================================================
     * */
    updateUser(userObject) {

        let formData = new FormData();
        // Required Values for this API Call

        formData.append('token', this.getToken());
        userObject.HomeReport = userObject.HomeReportId ? userObject.HomeReportId : constants.DEFAULT_GROUP_ID;
        delete userObject.HomeReportId;

        userObject.StateProvince = userObject.StateProvince || constants.DEFAULT_GROUP_ID;
        $.each(userObject, function (property, value) {
            formData.append(utils.firstToLowerCase(property), value || '');
        });

        var params = {
            "url": this.apiHostUrl + "/User",
            "method": "PUT",
            "data": formData,
            "contentType": false,
            "mimeType": "multipart/form-data"
        };
        var settings = this.getSettings(params);
        console.log('Settings', settings);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                   //Remove users cache
                    self._removeAllUsersCache();
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}`);
                }
                self.setToken(response.RESULT.TOKEN);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for checking the user session
     * =============================================================================
     * */
    checkUserSession(userId) {

        return new Promise((resolve, reject) => {

            let tokenVal = this.getToken();

            if(!tokenVal || typeof tokenVal === 'undefined'){
                console.log("The session token is undefined", tokenVal);
                console.trace("Undefined session token");
            }
            
            const url = this.apiHostUrl + `/common/CheckValidToken?token=${this.getToken()}&userId=${userId}`;
        
            $.get(url)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE');
                      
                    if (parseInt(errorCode) === 0) {
                        resolve();
                    } else {
                        reject(restMessages.codeToMessage(errorCode));
                    }

                })
                .fail(err => {
                    reject(err);
                });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving details of an Open Instance on View Forms.
     * =============================================================================
     * */
    getViewableInstanceDetails(formInstanceId) {
        const url = this.apiHostUrl + '/App/ViewableInstanceDetails?token=' + this.getToken() + '&formInstanceId=' + formInstanceId;
        return new Promise((resolve, reject) => {
            let self = this;
            $.get(url).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving no attention needed notifications.
     * =============================================================================
     * */
    getNotifications(isAttentionNeeded = false) {

        const postParams = {
            token: this.getToken(),
            fromAttentionLevel: isAttentionNeeded ? 1 : 0,
            toAttentionLevel: isAttentionNeeded ? 5 : 0
        };
        const url = this.apiHostUrl + '/Notifications/Browse';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving notification dashboard.
     * =============================================================================
     * */
    getDashboardNotifications(failedEmails=false){
        const postParams = {
            token: this.getToken(),
            failedEmails: failedEmails
        };
        const url = this.apiHostUrl + '/Notifications/Dashboard';
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                spinner.stop();
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving details about a notification.
     * =============================================================================
     * */
    getNotificationDetails(notificationId) {

        const postParams = {
            token: this.getToken(),
            notificationId:notificationId
        };
        const url = this.apiHostUrl + '/Notifications/Details',
        spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /*==============================================================================
    * Rest API call for retrying a failed email.
    * =============================================================================
    * */
    retryFailedEmails(failedEmailIds) {

        const postParams = {
            token: this.getToken(),
            failedEmailIds:failedEmailIds
        };
        const url = this.apiHostUrl + '/App/RetryFailedEmails',
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    /*==============================================================================
   * Rest API call for rename the user name
   * =============================================================================
   * */

    updateUserName(userId,firstName, lastName) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("userId", userId);
        formData.append("firstName", firstName);
        formData.append("lastName", lastName);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/user/renameuser',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*==============================================================================
  * Rest API call for rename the user group name
  * =============================================================================
  * */

    updateUserGroupName(groupId, name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("groupId", groupId);
        formData.append("name", name);


        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/user/renameusergroup',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }


    /*==============================================================================
  * Rest API call for rename the position name
  * =============================================================================
  * */

    updatePositionName(positionId, name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("positionId", positionId);
        formData.append("name", name);


        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/user/renameposition',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*==============================================================================
    * Rest API call for rename the connection name
    * =============================================================================
    * */

    updateConnectionName(connectionId,name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("connectionId", connectionId);
        formData.append("name", name);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/integration/renameconnection',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }


    /*==============================================================================
    * Rest API call for rename the action name
    * =============================================================================
    * */

    updateActionName(actionId, connectionId,name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("actionId", actionId);
        formData.append("connectionId", connectionId);
        formData.append("name", name);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/integration/renameaction',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }



    /*==============================================================================
    * Rest API call for rename the form name
    * =============================================================================
    * */

    updateFormName(formId,name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("formId", formId);
        formData.append("name", name);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/App/Rename',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    /*==============================================================================
    * Rest API call for rename the report name
    * =============================================================================
    * */

    updateReportName(reportId,name) {

        const formData = new FormData();
        formData.append("token", this.getToken());
        formData.append("reportId", reportId);
        formData.append("name", name);

        const settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Report/Rename',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
            const self = this;
            $.ajax(settings).done(function (data) {
                const response = JSON.parse(data);

                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;

    }

    // Obsolete
    /*==============================================================================
     * Rest API call for retrieving open instances of a form.
     * =============================================================================
     * */
    getOpenInstances(formId) {


        let form = new FormData();
        form.append('token', this.getToken());
        form.append('formId', formId);


        let formsRequestObject = {
            url: this.apiHostUrl + '/App/BrowseInstances',
            data: form,
            method: 'POST'
        };
        let settings = this.getSettings(formsRequestObject);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for retrieving open/closed instances of a form.
     * =============================================================================
     * */
    getFormInstances(formId, isClosed, isArchived) {

        /*
         let form = new FormData();
         form.append('token', this.getToken());
         form.append('formId', formId);
         form.append('isClosed', isClosed);
         form.append('isArchived', isArchived);

         let formsRequestObject = {
         url: this.apiHostUrl + '/App/BrowseInstances',
         data: form,
         method: 'POST'
         };
         let settings = this.getSettings(formsRequestObject);
         */
        const postParams = {
            token: this.getToken(),
            formId: formId,
            isClosed: isClosed,
            isArchived: isArchived
        };
        const url = this.apiHostUrl + '/App/BrowseInstances';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);
                
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });

    }

    /* ==============================================================================
     * Rest API call for retrieving connections on a connect behavior component.
     * =============================================================================
     * */
    getConnections(formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID,
                   type = constants.BEHAVIOR_CONNECTIONS_TYPE,
                   purpose = constants.BEHAVIOR_CONNECTIONS_PURPOSE) {

        const postParams = {
            token: this.getToken(),
            formId: formId,
            type: type,
            purpose: purpose
        };


        const url = this.apiHostUrl + '/Integration/BrowseConnections';


        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    let connections = response.RESULT.RESPONSE.ConnectionList ? response.RESULT.RESPONSE.ConnectionList.Connection : [];
                    console.log('Current Connections', connections);
                    if (connections instanceof Array) {
                        resolve(connections);
                    }
                    else {
                        resolve([connections])
                    }
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            });
        });
    }

     /* ==============================================================================
     * Rest API call for retrieving connections for autocomplete
     * =============================================================================
     * */
    getConnectionsAutocomplete(formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID) {

        const postParams = {
            token: this.getToken(),
            formId: formId
        };

        const url = this.apiHostUrl + '/Integration/BrowseConnectionsAutocomplete';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    let connections = response.RESULT.RESPONSE.ConnectionList ? response.RESULT.RESPONSE.ConnectionList.Connection : [];
                    console.log('Current Connections', connections);
                    if (connections instanceof Array) {
                        resolve(connections);
                    }
                    else {
                        resolve([connections])
                    }
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            });
        });
    }
    checkConnection(object) {
        console.log(object);

        let form = new FormData();
        form.append("token", this.getToken());
        form.append("URL", object._url + '/GetResourcesList');
        form.append("method", 'WebServiceCall');
        form.append("requestObject", 'password=' + md5(object._password) +
            '&username=' + md5(object._username) +
            '&versionNumber=1.09&type=sql');
        form.append("webServiceType", 'POST');
        form.append("targetNamespace", '');
        form.append("username", constants.DEFAULT_GROUP_ID);
        form.append("password", constants.DEFAULT_GROUP_ID);
        form.append('requestHeader', constants.DEFAULT_GROUP_ID);


        console.log(form);

        let settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/WebServiceCall',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": form
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    checkAction(object) {
        console.log(object);


        let formData = new FormData();
        formData.append('token', this.getToken());
        $.each(object, function (property, value) {
            formData.append(property, value || '');
        });

        console.log(formData);

        let settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/WebServiceCall',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.DIALOG_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);

                    if(response.RESULT.METADATA){
                        reject(response.RESULT);
                    }
                    else{
                        reject(error);
                    }
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(jqXHR);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    checkRESTAction(object) {
        console.log(object);


        let formData = new FormData();
        formData.append('token', this.getToken());
        $.each(object, function (property, value) {
            formData.append(property, value || '');
        });

        console.log(formData);

        let settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/RestWebServiceCall',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };

        const spinner = new Spinner().spin($(constants.DIALOG_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                if(response.RESULT.STATUSCODE)
                {
                    response.STATUSCODE = parseInt(response.RESULT.STATUSCODE);
                }
                
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);

                    if(response.RESULT.METADATA){
                        reject(response.RESULT);
                    }
                    else{
                        reject(error);
                    }
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(jqXHR);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }


    checkGeneralAction(object,resource) {


        let postParams=Object.assign({},{token:this.getToken},object);
        const spinner = new Spinner().spin($(constants.DIALOG_ID).get(0)),
              url = this.apiHostUrl + resource;

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(jqXHR);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    checkGeneralActionNoProxy(object, resource) {
        let postParams = Object.assign({}, { token: this.getToken }, object);
        const url = resource;
        const spinner = new Spinner().spin($(constants.DIALOG_ID).get(0))
        return new Promise((resolve, reject) => {
            $.post(url, postParams).done(function (data) {

                let response = $(data);
                let error = response.find('error'),
                    serverResponse = response.find('response');

                if (error.text() === "" && serverResponse !== undefined) {
                    resolve(serverResponse);
                } else {
                    reject({
                        MESSAGE: error.attr('message')
                    });
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(jqXHR);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    getAutoCompleteData(object, tableName, type) {
        const xmlAutoComplete = `xmlParams=<request><send/><receive/><tables><table name="${tableName}"/></tables></request>&databaseId=${object._databaseId}&versionNumber=1.09&username=${md5(object._username)}&datasourceId=${object._datasourceId}&password=${md5(object._password)}&datasourceType=sql`;

        console.log('Auto',xmlAutoComplete);

        let form = new FormData();
        form.append("token", this.getToken());
        if (type === '7') {
            form.append("URL", `${object._url}/GetCsvColumnNames`);
        }
        else {
            form.append("URL", `${object._url}/GetColumnNames`);
        }
        form.append("method", 'WebServiceCall');
        form.append("requestObject", encodeURIComponent(xmlAutoComplete));
        form.append("webServiceType", 'POST');
        form.append("targetNamespace", '');
        form.append("username", constants.DEFAULT_GROUP_ID);
        form.append("password", constants.DEFAULT_GROUP_ID);
        form.append('requestHeader', constants.DEFAULT_GROUP_ID);
        console.log(form);

        let settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Integration/WebServiceCall',
            "method": "POST",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": form
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                let response = JSON.parse(data);
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /* ==============================================================================
     * Rest API call for checking connections without SSL
     * =============================================================================
     * */
    getResourcesList(connectionObject) {

        const postParams = {
            token: this.getToken(),
            username: md5(connectionObject._username),
            password: md5(connectionObject._password),
            versionNumber:'1.09',
            type:'sql'
        };


        const url = `${connectionObject._url}/GetResourcesList`;


        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            $.post(url,postParams).done(function (response) {
                if (response && response.children[0].children[0].tagName !== "error") {
                    resolve(response);
                } else {
                    let errMsg = "Unknown error";
                    try {
                        errMsg = response.children[0].children[0].getAttribute("message");
                    }
                    catch (err) { }

                    reject(errMsg);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(jqXHR,textStatus,errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /* ==============================================================================
     * Rest API call for retrieving a Synchronization Profile
     * =============================================================================
     * */
      getSynchronizationProfile() {

        const postParams = {
          token: this.getToken()
        };


        const url = `${this.apiHostUrl}/User/SynchronizationProfile`;
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
          let self = this;
          $.get(url, postParams).done(function(data) {
            var response = data;
            var error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = response.RESULT.RESPONSE.UserSynchronizationProfileXML !== null
                    ? _.get(response, 'RESULT.RESPONSE.UserSynchronizationProfileXML.UsersSynchronizationProfile')
                    : response.RESULT.RESPONSE.UserSynchronizationProfileXML;
            self.setToken(response.RESULT.TOKEN);
            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              resolve(serverResponse);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }

          }).fail(function(jqXHR, textStatus, errorThrown) {
            reject(jqXHR);
          }).always(() => {
            spinner.stop();
          });
        });
      }

    /* ==============================================================================
     * Rest API call for testing a synchronization profile.
     * =============================================================================
     * */
      testSynchronizationProfile() {

        const postParams = {
          token: this.getToken()
        };


        const url = `${this.apiHostUrl}/User/TestSynchronizationProfile`;
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
          let self = this;
          $.post(url, postParams).done(function(data) {
            var response = data;
            var error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');
            self.setToken(response.RESULT.TOKEN);
            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              resolve(serverResponse);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }

          }).fail(function(jqXHR, textStatus, errorThrown) {
            reject(jqXHR);
          }).always(() => {
            spinner.stop();
          });
        });
      }

    /*======================================================================
       * Rest API call for updating the details of a report.
       * ======================================================================
    * */
      updateSynchronizationProfile(profileXML) {
        console.log('in rest service', arguments);

        let formData = new FormData();
        formData.append("token", this.getToken());
        formData.append('profileXML',profileXML);

        console.log(`Profile XML: `, profileXML);

        let settings = {
          "async": true,
          "crossDomain": true,
          "url": this.apiHostUrl + '/User/UpdateSynchronizationProfile',
          "method": "PUT",
          "headers": {
            "cache-control": "no-cache"
          },
          "processData": false,
          "contentType": false,
          "mimeType": "multipart/form-data",
          "data": formData
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        const promise = new Promise((resolve, reject) => {
          const self = this;
          $.ajax(settings).done(function (data) {
            const response = JSON.parse(data);
            const error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE');
            self.setToken(response.RESULT.TOKEN);

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
              resolve(response);
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                reject(error);
            }

          }).fail(function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown);
          }).always(() => {
            spinner.stop();
          });
        });

        return promise;

      }


    /* ==============================================================================
     * Rest API call for retrieving data for current logged account.
     * =============================================================================
     * */
    getAccountDetails() {
        const
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
            postParams = {
                token: this.getToken(),
                updateIndicators: false
            };
        const url = this.apiHostUrl + '/Account/AccountDetails';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    console.log('getAccountDetails response', response);
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(err => {
                console.log('Account Details error: ', err);
                reject(err);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /* ==============================================================================
     * Rest API call for retrieving account data specific to forms
     * =============================================================================
     * */
    getDetailsForDesigner() {
        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));        
            
        const url = this.apiHostUrl + '/Account/AccountDetailsForDesigner?token=' + this.getToken();
        let settings = {
            "async": true,
            "url": url,
            "method": "GET"
        };    
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    errorMessage = _.get(error, 'MESSAGE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    let message = restMessages.codeToMessage(errorCode);
                    message += errorMessage ? ': ' + errorMessage : '';
                    reject(message);
                }
            }).fail(err => {
                console.log('Account Details error: ', err);
                reject(err.responseJSON.message);
            }).always(() => {
                spinner.stop();
            });
        });
    }

    /* ==============================================================================
     * Rest API call for list all forms names.
     * =============================================================================
     * */
    getFormList(permission) {
        const
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
            postParams = {
                token: this.getToken(),
                permission: permission
            };
        const url = this.apiHostUrl + '/App/List';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    console.log('This is the response', response);
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(err => {
                console.log('App List error: ', err);
                reject(err);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    /* ==============================================================================
   * Rest API call for list all forms instances.
   * =============================================================================
   * */
    getAllInstances() {
        const
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
            postParams = {
                token: this.getToken(),
                formId:constants.DEFAULT_GROUP_ID
            };
        const url = this.apiHostUrl + '/App/GetManageFormInstancesSummary';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    console.log('This is the response', response);
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(err => {
                console.log('App List error: ', err);
                reject(err);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    /*==============================================================================
     * Rest API call for retrieving actions by a given connection Id on a connect behavior component.
     * =============================================================================
     * */
    getActionsByConnectionId(connectionId,
                             formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID,
                             purpose = constants.BEHAVIOR_CONNECTIONS_PURPOSE) {
        return restServiceAux.getActionsByConnectionId(connectionId, formId, purpose  );

/*        const postParams = {
            token: this.getToken(),
            connectionId: connectionId,
            formId: formId,
            purpose: purpose
        };


        const url = this.apiHostUrl + '/Integration/BrowseActions';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    let actions = response.RESULT.RESPONSE.ActionList ? response.RESULT.RESPONSE.ActionList.Action : [];
                    if (actions instanceof Array) {
                        resolve(actions);
                    }
                    else {
                        resolve([actions])
                    }
                    // Set the token just if the post don't receive errors, to avoid get disconnected on multiple calls
                    self.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                } else {
                    self.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });*/
    }

    /*==============================================================================
     * Rest API call for retrieving actions of type select, get or read for autocomplete
     * =============================================================================
     * */
    getActionsAutocomplete(connectionId, formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID) {
        const self = this;

        const postParams = {
            token: self.getToken(),
            connectionId: connectionId,
            formId: formId
        };

        const url = `${self.apiHostUrl}/Integration/BrowseActionsAutocomplete`,
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {

            $.post(url, postParams).done(function (response) {
                spinner.stop();
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    const actions = utils.enforceArrayType(response.RESULT.RESPONSE.ActionList ? response.RESULT.RESPONSE.ActionList.Action : []);

                    // Set the token just if the post don't receive errors, to avoid get disconnected on multiple calls
                    self.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                    resolve(actions);
                } else if (parseInt(errorCode) === 2) {
                    // Can be expected on a large input set. If it is a "read" error 2 it will manifest on the next call.
                    listService.removePromiseInProgress(connectionId);
                    reject(error);
                } else {
                    console.log(`===> ERROR: getActionsByConnectionId ${errorCode}`, response);
                    self.setToken(response.RESULT.TOKEN);
                    listService.removePromiseInProgress(connectionId);
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    /*====================================================================================================
     * Rest API call for retrieving actions by a given connection Id on a connect behavior component.
     * ===================================================================================================
     * */
    getParametersByActionIdAndConnectionId(actionId,
                                           connectionId,
                                           formId = constants.BEHAVIOR_CONNECTIONS_FORM_ID,
                                           purpose = constants.BEHAVIOR_CONNECTIONS_PURPOSE,
                                           detailsData = false) {

        // Delegate to smaller module thta is debuggable (and shrinking this module a little)
        return restServiceAux.getParametersByActionIdAndConnectionId(actionId,
            connectionId,
            formId,
            purpose,
            detailsData);
    }

    /*====================================================================================================
     * Rest API call for retrieve the url to the user in order to update its account
     * ===================================================================================================
     * */
    getSignUpMethod() {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner =$(constants.LOADING),
                url = `${this.apiHostUrl}/Account/GetSignUpMethod`,
                token = this.getToken();

            let params = {token: token === 'undefined'? constants.DEFAULT_TOKEN : token };
            spinner.find('h4').text('Please wait...');
            spinner.show();
            $.post(url, params)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('move report error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.hide();
                });

        });
    }


    /*==============================================================================
     * Rest API call for getting the list of email servers
     * =============================================================================
     */
    getEmailServers() {
        const postParams = {
            token: this.getToken()
        };
        const url = this.apiHostUrl + '/Account/BrowseEmailServers';
        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                
                self.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    let EmailServersList = _.get(response, 'RESULT.RESPONSE.EmailServers.EmailServer');
                    resolve(EmailServersList);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    /*==============================================================================
     * Rest API call for deleting an email server.
     * =============================================================================
     */
    deleteEmailServer(emailServerId) {

        var form = new FormData();
        form.append("token", this.getToken());
        form.append("emailServerID", emailServerId);

        var settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Account/DeleteEmailServer',
            "method": "DELETE",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": form
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    /*==============================================================================
     * Rest API call for deleting a custom list.
     * =============================================================================
     */
    deleteCustomList(customListId) {

        var form = new FormData();
        form.append("token", this.getToken());
        form.append("customListId", customListId);

        var settings = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/Account/DeleteCustomList',
            "method": "DELETE",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": form
        };

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });

        return promise;
    }

    undeleteCustomList(customListId) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                async: true,
                headers: {
                    "cache-control": "no-cache"
                },
                url: this.apiHostUrl + '/account/UndeleteCustomList',
                data: {token: this.getToken(), customListId: customListId},
                success: function (data) {
                    // successful request; do something with the data
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'User successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    getPersonalDetails(userId) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/User/SimpleUserDetails`;

            const postParams = {
                token: this.getToken(),
                userId
            };

            $.get(url, postParams)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('Error on retrieving user data: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    /*==============================================================================
     * Rest API call for updating personal details.
     * =============================================================================
     * */
    updatePersonalDetails(personalDetailsObject) {

        let formData = new FormData();
        // Required Values for this API Call

        formData.append('token', this.getToken());

        //personalDetailsObject.StateProvince=personalDetailsObject.StateProvince || constants.DEFAULT_GROUP_ID;
        $.each(personalDetailsObject, function (property, value) {
            formData.append(utils.firstToLowerCase(property), value || '');
        });

        var params = {
            "async": true,
            "crossDomain": true,
            "url": this.apiHostUrl + '/User/UpdateSimpleUser',
            "method": "PUT",
            "headers": {
                "cache-control": "no-cache"
            },
            "processData": false,
            "contentType": false,
            "mimeType": "multipart/form-data",
            "data": formData
        };
        var settings = this.getSettings(params);
        console.log('Settings', settings);
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(function (data) {
                var response = JSON.parse(data);
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    getCustomList(customListId, fullData = false) {
        const postParams = {
            token: this.getToken(),
            customListId: customListId
        };
        const url = this.apiHostUrl + '/Account/GetCustomList',
              spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        let self = this;
        return new Promise((resolve, reject) => {
            $.post(url, postParams).done((response) => {
                spinner.stop();
                const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    if (fullData) {
                        resolve(_.get(response, 'RESULT.RESPONSE') || []);
                    }
                    else {
                        resolve(_.get(response, 'RESULT.RESPONSE.CustomListXML.CustomList.Item') || []);
                    }

                    this.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                spinner.stop();
                reject(errorThrown);
            });
        });
    }

    updateCustomList({customListId, name, customListXML}) {
        const postParams = {
            token: this.getToken(),
            dataType: 'JSON',
            customListId,
            name,
            customListXML

        };
        const url = this.apiHostUrl + '/Account/UpdateCustomList';
        const self = this;
        return new Promise((resolve, reject) => {
            $.post(url, postParams).done((response) => {
                const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(serverResponse);
                    this.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }

    browseCustomList() {
        const postParams = {
            token: this.getToken()
        };
        const url = this.apiHostUrl + '/Account/BrowseCustomList';
        const self = this;

        return new Promise((resolve, reject) => {
            $.post(url, postParams).done((response) => {
                const
                    error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');                
                this.setToken(response.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    let CustomLists = _.get(response, 'RESULT.RESPONSE.CustomLists.CustomList') || [];
                    resolve(CustomLists);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
    }


    playForm(id) {

        let instanceUrl = this.hostUrl + '/player.htm?f=' +  id +'&viewReport=true';
        const attributes = { url: instanceUrl, id: id};
        const newPlayForm = new PlayFormModal({model: new Model(attributes) });

        newPlayForm.render().then((result) => {});
    }

    login(data, callback) {
        const postParams = {
            accountName: data.account,
            userName: data.userName,
            password: data.password,
            createLoginToken: data.createLoginToken,
            type: data.type === undefined ? 1 : data.type,
            token: data.token,
            directoryServiceUserName: data.directoryServiceUserName,
            anonymousAccountId: data.anonymousAccountId,
            loginToken: data.loginToken,
            dataType: 'JSON'
        };
        let self = this;

        utils.isLoggedIn = false;
        const spinner =$(constants.LOADING);
        spinner.find('h4').text('Logging in...');
        spinner.show();
        const url = (this.apiHostUrl || data.apiHostUrl) + '/Login';
        $.post({url: url, "headers": {
                "cache-control": "no-store"
            }
        }, postParams).done(response => {
            //This is an error on their encoding, leaving like this for now
            const
                error = _.get(response, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                serverResponse = _.get(response, 'RESULT.RESPONSE'),
                token = _.get(response, 'RESULT.TOKEN');
                

                constants.CURRENT_VERSION = serverResponse.Version || constants.CURRENT_VERSION;

            if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                utils.isLoggedIn = true;
                console.log("Server Response", serverResponse);
               
                listService.accountSettings = serverResponse;
                window.localStorage.setItem("inputHideMsg", false);
                window.localStorage.setItem('DirectoryServiceGatewayURL', serverResponse.DirectoryServiceGatewayURL);
                window.localStorage.setItem('DirectoryServiceEnabled', serverResponse.DirectoryServiceEnabled);

                if(serverResponse.Accounts && Array.isArray(serverResponse.Accounts.Account)){
                    callback(serverResponse.Accounts.Account);
                }else{
                    this.setToken(serverResponse.Token);
                    this.setProfile(serverResponse);
                    listService.userProfile =serverResponse;

                    userService.setUserRoles(serverResponse.Roles, serverResponse.LibraryEnabled, serverResponse.ArchivingEnabled);
                    //this.setUser(serverResponse);

                    let settingsValue = '';
                    if (serverResponse.SettingsXML) {
                        settingsValue = serverResponse.SettingsXML['#cdata-section'];
                    }

                    if(utils.isTrue(serverResponse.IsBULicense) && serverResponse.SalesEmailAddress){
                        listService.salesEmailAddress = serverResponse.SalesEmailAddress;
                    }

                    userService.setUserSettings(settingsValue);
                    userService.setUserFeatures(serverResponse.Features);
                    listService.wasDesginerOpened = false;

                    if(serverResponse.HomeReport && serverResponse.Status==='1' && !data.resetPassword){
                        this.setToken(serverResponse.Token);
                        this.playForm(serverResponse.HomeReport, serverResponse.Status);
                        return;
                    }
                    callback(false);
                }
            } else {
                self.checkErrorCodeUserNotAuthenticated(errorCode);
                switch (errorCode) {
                    case constants.ERROR_CODE_USER_PASSWORD_NOT_RECOGNIZED:
                        error.MESSAGE = constants.ERROR_MSG_USER_PASSWORD_NOT_RECOGNIZED;
                        break;
                    case constants.ERROR_CODE_TEMPORARY_PASSWORD_EXPIRED_OR_INACTVE_USER:
                        error.MESSAGE = constants.ERROR_MSG_TEMPORARY_PASSWORD_EXPIRED_OR_INACTVE_USER;
                        break;
                    case constants.ERROR_CODE_TEMPORARY_PASSWORD_ALREADY_USED:
                        error.MESSAGE = constants.ERROR_MSG_TEMPORARY_PASSWORD_ALREADY_USED;
                        break;
                    case constants.ERROR_CODE_LOG_IN_ALLOWED_ONLY_IF_DOMAIN_AUTHENTICATED:
                        error.MESSAGE = constants.ERROR_MSG_LOG_IN_ALLOWED_ONLY_IF_DOMAIN_AUTHENTICATED;
                        break;
                    case constants.ERROR_CODE_ACCOUNT_EXPIRED:
                        error.MESSAGE = constants.ERROR_MSG_ACCOUNT_EXPIRED;
                        break;
                    case constants.ERROR_CODE_TRIAL_ACCOUNT_EXPIRED:
                        this.setEmail($('input[name=userName]').val());
                        Backbone.history.loadUrl('trialExpired');
                        this.setToken(token);
                        break;
                    case constants.ERROR_CODE_SYSTEM_EXPIRED:
                        error.MESSAGE = constants.ERROR_MSG_SYSTEM_EXPIRED;
                        break;
                }
                callback(error);
            }
        }).fail((err) => {
            callback(err);
        }).always(() => {
            spinner.hide();
        });
    }

    logout() {
        let sHHelpCenterChanged = sessionStorage.getItem("editorShowHelpCenterChanged") === 'true';
        const
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
            postParams = {
                token: this.getToken(),
                settingsXML: sHHelpCenterChanged ? zLib.compressForm(userService.populateUserSettingsFromApp())
                                                      : constants.DEFAULT_GROUP_ID
            };
        const url = this.apiHostUrl + '/Logout';
        return new Promise((resolve, reject) => {
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                if ((parseInt(errorCode) === 0 || parseInt(errorCode) === 2 )&& serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    reject(error);
                }
            }).fail(err => {
                console.log('Logout error : ', err);
                reject(err);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    signUp(model) {
        return new Promise((resolve, reject) => {
            const spinner =$(constants.LOADING);
            const requestData = {
                firstName: model.get('firstName'),
                lastName: model.get('lastName'),
                company: '',
                email: model.get('email'),
                phone: '',
                jobTitle: '',
                companySize: '',
                howDidYouHear: '',
                country: '',
                //This number appears to be hardcoded on devel.perfectforms.com
                partnerId: '-9223372036854775808',
                checkForExistingUser: true,
                password: model.get('password'),
                type: 0,
                anonymousAccountId: '-9223372036854775808',
                brand: 0
            };

            const url = this.apiHostUrl + '/Account/SignUp';
            spinner.find('h4').text('Please wait...');
            spinner.show();

            $.post(url, requestData)
                .done(function (response) {
                    const result = response.RESULT.RESPONSE;
                    const error = response.RESULT.ERROR;

                    const errorCodes = {
                        '0': {displayError: ''},
                        '7': {displayError: 'Please review your inputs'}
                    };

                    let message = "";

                    //Just in case we get some code we are not ready for, saves us from doing a for looking up error codes.
                    try {
                        message = errorCodes[error.CODE].displayError;
                    } catch (e) {
                        message = 'An error has occurred, if this behaviour continues please contact support@pf.com';
                    }

                    if (error.CODE !== '0') {
                        reject(`${restMessages.codeToMessage(error.CODE)}: ${message}`);
                    } else {
                        resolve(false, result);
                    }

                }).fail(function (error) {
                        reject(error);
                }).always(() => {
                    spinner.hide();
                });
        })

    }

    //==============================================================================
    // Given a formId, majorVersion, minorVersion, returns a PROMISE of
    // a raw payload containing formXml.
    // Caller should extract the settled result using a
    // promise.then(resolvedFn, rejectedFn).
    //==============================================================================
    openForm(formId, majorVersion, minorVersion, restoreRecovery) {

        return new Promise((resolve, reject) => {

            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            let self = this;

            // http://devel.perfectforms.com/REST/api/App/Open?token=-1555976622491959296&formId=15099&majorVersion=0&minorVersion=1
            const url =
                `${this.apiHostUrl}/App/Open?token=${this.token}&formId=${formId}&majorVersion=${majorVersion}&minorVersion=${minorVersion}&restoreRecovery=${restoreRecovery}`;

            $.get(url)
                .done(data => {
                    // console.log(data);
                    const
                        dataObj = data,
                        error = _.get(dataObj, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(dataObj, 'RESULT.RESPONSE');

                    this.token = _.get(dataObj, 'RESULT.TOKEN');
                    // console.log(`1 form open result token`, this.token);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('openApp error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }


    //==============================================================================
    // Given a reportID, majorVersion, minorVersion, returns a PROMISE of
    // a raw payload containing reportXml.
    // Caller should extract the settled result using a
    // promise.then(resolvedFn, rejectedFn).
    //==============================================================================
    openReport(reportId, majorVersion, minorVersion, restoreRecovery) {

        return new Promise((resolve, reject) => {

            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

            // POST http://devel.perfectforms.com/REST/api/Report/Open
            // Formdata example :

            // token: 12341234 (new token with each REST Response)
            // reportId: 15126
            // majorVersion: 0
            // minorVersion: 1

            const url = `${this.apiHostUrl}/Report/Open`;
            const postParams = {
                token: this.token,
                reportId: reportId,
                majorVersion: majorVersion,
                minorVersion: minorVersion,
                restoreRecovery: restoreRecovery
            };
            let self = this;

            $.post(url, postParams)
                .done(data => {
                    // console.log(data);
                    const
                        dataObj = data,
                        error = _.get(dataObj, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(dataObj, 'RESULT.RESPONSE');

                    this.token = _.get(dataObj, 'RESULT.TOKEN');
                    console.log(`1 report open result token`, this.token);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('openReport error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }


    //==================================================================================================
    // Given a proper /App/Add request packet, return an ES6 PROMISE of a response packet.
    //
    // See wiki http://wiki.intuitivesolutions.org:8090/pages/viewpage.action?pageId=753721
    // for /App/Add request format. Don't worry about the token value. We maintain that here.
    //==================================================================================================
    addForm({formXML, formName, groupId, isPrivate}) {

        return new Promise((resolve, reject) => {

            const
                url = `${this.apiHostUrl}/App/Add`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;
            
            fd['token'] = this.getToken();
            fd['name'] = formName;
            fd['formXML'] = formXML;
            fd['groupId'] = !isPrivate && !groupId ? constants.DEFAULT_GROUP_ID : groupId;
            fd['width'] = 400;
            fd['height'] = 600;
            fd['isPrivate'] = isPrivate;
            fd['formGUID'] = guidUtil.encodedGuid;

            $.post(url, fd)
                .done(data => {
                    console.log(data);
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        self.setToken(this.token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(payLoad);
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                                              
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('add app error: ', err);
                    reject(err);
                })
                .always(() => {
                    // console.log('stopping spinner');
                    spinner.stop();
                });

        });
    }

    //==================================================================================================
    // Saves current form contents as a new form in the server.
    //
    // Given a proper /App/Save request packet, return an ES6 PROMISE of a response packet.
    //
    // See wiki http://wiki.intuitivesolutions.org:8090/pages/viewpage.action?pageId=753721
    // for /App/Add request format. Don't worry about the token value. We maintain that here.
    //==================================================================================================
    saveAsNewForm(param, groupId) {

        return new Promise((resolve, reject) => {

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                formGUID = guidUtil.encodedGuid,
                url = `${this.apiHostUrl}/App/SaveNew`;
            let self = this;

            param.token = this.token;
            param.formGUID = formGUID;

            $.post(url, param)
                .done(data => {
                    if(data.RESULT && data.RESULT.RESPONSE){
                        data.RESULT.RESPONSE.formGUID = formGUID;
                    }
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('save as new app error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    //==================================================================================================
    // Replaces contents of current form in the server.
    //
    // Given a proper /App/Save request packet, return an ES6 PROMISE of a response packet.
    //
    // See wiki http://wiki.intuitivesolutions.org:8090/pages/viewpage.action?pageId=753721
    // for /App/Add request format. Don't worry about the token value. We maintain that here.
    //==================================================================================================
    saveForm(param, groupId) {
        let formData = new FormData();
        listService.userSettings.set('_moShHC', "false");
        listService.userSettings.set('_moShAS', "true");
        formData.append('token', this.getToken());

        $.each(param, function (property, value) {
            if(value){
                formData.append(utils.firstToLowerCase(property), value.toString());
            }
        });

        const saveUrl = !listService.isRecoverySave ?  '/App/Save' : '/App/SaveRecovery';

        let formsRequestObject = {
            url: this.apiHostUrl + saveUrl,
            data: formData,
            processData: false,
            contentType: false,
            method: 'POST'
        };

        let settings = this.getSettings(formsRequestObject);        
        const spinner = new Spinner();
        
        if(!listService.isRecoverySave){
            spinner.spin($(constants.CONTENT_ID).get(0));
        }

        listService.isRecoverySave = false;

        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(data => {
                const
                    error = _.get(data, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    payLoad = _.get(data, 'RESULT.RESPONSE');

                self.setToken(data.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && payLoad) {
                    resolve(payLoad);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject([`${restMessages.codeToMessage(errorCode)}: ${message}`, errorCode]);
                }

            })
                .fail(function( jqxhr, textStatus, errorThrown ) {
                    // if the first attemp has failed
                    if( jqxhr.status === 0 ){
                        // we don't have a specific error try again
                        $.ajax(this).done(data => {
                            const
                                error = _.get(data, 'RESULT.ERROR'),
                                errorCode = _.get(error, 'CODE'),
                                message = _.get(error, 'MESSAGE', ''),
                                payLoad = _.get(data, 'RESULT.RESPONSE');

                            self.setToken(data.RESULT.TOKEN);

                            if (parseInt(errorCode) === 0 && payLoad) {
                                resolve(payLoad);
                            } else {
                                reject([`${restMessages.codeToMessage(errorCode)}: ${message}`, errorCode]);
                            }

                        }).fail(err => {
                            console.log('save app error: ', err.responseText);
                            reject(err.statusText);
                        });
                    }else{
                        console.log('save app error: ', jqxhr.responseText);
                        reject(errorThrown);
                    }
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    saveMobileForm(param, groupId) {
        let formData = new FormData();

        formData.append('token', this.getToken());

        $.each(param, function (property, value) {
            if(value){
                formData.append(utils.firstToLowerCase(property), value.toString());
            }
        });

        let formsRequestObject = {
            url: this.apiHostUrl + '/App/SaveView',
            data: formData,
            processData: false,
            contentType: false,
            method: 'POST'
        };
        let settings = this.getSettings(formsRequestObject);

        const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax(settings).done(data => {
                const
                    error = _.get(data, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    payLoad = _.get(data, 'RESULT.RESPONSE');

                self.setToken(data.RESULT.TOKEN);

                if (parseInt(errorCode) === 0 && payLoad) {
                    resolve(payLoad);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject([`${restMessages.codeToMessage(errorCode)}: ${message}`, errorCode]);
                }

            })
                .fail(function( jqxhr, textStatus, errorThrown ) {
                    // if the first attemp has failed
                    if( jqxhr.status === 0 ){
                        // we don't have a specific error try again
                        $.ajax(this).done(data => {
                            const
                                error = _.get(data, 'RESULT.ERROR'),
                                errorCode = _.get(error, 'CODE'),
                                message = _.get(error, 'MESSAGE', ''),
                                payLoad = _.get(data, 'RESULT.RESPONSE');

                            self.setToken(data.RESULT.TOKEN);

                            if (parseInt(errorCode) === 0 && payLoad) {
                                resolve(payLoad);
                            } else {
                                reject([`${restMessages.codeToMessage(errorCode)}: ${message}`, errorCode]);
                            }

                        }).fail(err => {
                            console.log('save app error: ', err.responseText);
                            reject(err.statusText);
                        });
                    }else{
                        console.log('save app error: ', jqxhr.responseText);
                        reject(errorThrown);
                    }
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    deployForm(formId) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/App/Deploy`;
            let param = {
                formId: formId,
                token: this.getToken()
            };

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        if (errorCode === "72") {
                            let specificMessage = "The app has duplicate field id's.";
                            reject(`${specificMessage}`);
                        } else {
                            reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                        }
                    }
                })
                .fail(err => {
                    console.log('Deploy app error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    shareForm(param) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/App/MoveForm`;

            param.token = this.getToken();

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('move app error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    getFormVersionsMapping(formId) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/App/GetFormVersionsMapping`;
            let param = {
                formId: formId,
                token: this.getToken()
            };

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        versionList = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && versionList && versionList.VersionList && versionList.VersionList.Version) {
                        if (!$.isArray(versionList.VersionList.Version)){
                            versionList.VersionList.Version = [versionList.VersionList.Version];
                        }
                        resolve(versionList);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    console.log('get app versions mapping error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    updateFormVersionsMapping(formId, versionList) {
        return new Promise((resolve, reject) => {
            let self = this;
            const _xml = XJService.jsToXml(versionList);
            let versionsXML = utils.escapeXMLString(XJService.xmlToString(_xml));
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/App/UpdateVersionsMapping`;
            let param = {
                formId: formId,
                token: this.getToken(),
                versionsXML: versionsXML
            };

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0) {
                        resolve();
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                })
                .fail(err => {
                    console.log('update app versions mapping error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    deployReport(reportId) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Report/Deploy`;
            let param = {
                reportId: reportId,
                token: this.getToken()
            };

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    console.log('move report error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    shareReport(param) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Report/Move`;

            param.token = this.getToken();

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('move report error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    resetReport(reportId) {
        return new Promise((resolve, reject) => {
            let self = this;
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Report/Reset`;

            let param = {
                reportId: reportId,
                token: this.getToken()
            };
            
            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    self.setToken(data.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('reset report error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }


    //==================================================================================================
    // Replaces contents of current report in the server.
    //
    // Given a proper /Report/Save request packet, return an ES6 PROMISE of a response packet.
    //
    // See wiki http://wiki.intuitivesolutions.org:8090/pages/viewpage.action?pageId=753721
    // for /Report/Save request format. Don't worry about the token value. We maintain that here.
    //==================================================================================================
    saveReport(param, groupId) {

        return new Promise((resolve, reject) => {

            const saveUrl = !listService.isRecoverySave ? "/Report/Save" : "/Report/SaveRecovery"

            const spinner = new Spinner();
        
            if(!listService.isRecoverySave){
                spinner.spin($(constants.CONTENT_ID).get(0));
            }

            listService.isRecoverySave = false;

            const url = param.isPreview ? `${this.apiHostUrl}/Report/SaveForPreview` : this.apiHostUrl + saveUrl;
            let self = this;

            param.token = this.token;

            if (param.isPreview){
                const reportXmlStr = zLib.decompressForm(param.reportXML);
                const reportDocPre = formulaService.preprocess( reportXmlStr );
                const reportXml = xjService.xmlDocToJs( reportDocPre );
                const reportXMLForPreview = {};

                reportXMLForPreview.Report = {};
                reportXMLForPreview.Report.DataSources = reportXml.Report.DataSources;
                reportXMLForPreview.Report.ReportingMetaData = reportXml.Report.ReportingMetaData;

                if (reportXMLForPreview.Report.DataSources &&
                    reportXMLForPreview.Report.DataSources.DataSource &&
                    reportXMLForPreview.Report.DataSources.DataSource.Filter &&
                    reportXMLForPreview.Report.DataSources.DataSource.Filter === '') {

                    reportXMLForPreview.Report.DataSources.DataSource.Filter = undefined;
                }
                const _xml = xjService.xmlToString( formulaService.postProcess( reportXMLForPreview ) );
                param.reportXML = zLib.compressForm(_xml);
            }

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(payLoad);
                    } else {
                        if (param.isPreview) {
                            let _param = utils.enforceArrayType(_.get(error, 'Param'));
                            let _parseMessage = message;
                            if (_param.length > 0){
                                $.each(_param, function(idx, item){
                                    if (item && typeof item['@name'] !== 'undefined' && typeof item['@value'] !== 'undefined'){
                                        _parseMessage = _parseMessage.replace(item['@name'], '<b>' + item['@value'] + '</b>');
                                    }
                                });
                            }
                            
                            reject([`${restMessages.codeToMessage(errorCode)}: ${_parseMessage}`, errorCode]);
                        }
                        else{
                            self.checkErrorCodeUserNotAuthenticated(errorCode);
                            reject([`${restMessages.codeToMessage(errorCode)}: ${message}`, errorCode]);
                        }
                    }
                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    addReport(reportXML, reportName, groupId,isPrivate) {

        return new Promise((resolve, reject) => {

            const
                url = `${this.apiHostUrl}/Report/Add`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['name'] = reportName;
            fd['reportXML'] = reportXML;
            fd['groupId'] = groupId;
            fd['width'] = 500;
            fd['height'] = 400;
            fd['isPrivate'] = isPrivate;
            fd['reportGUID'] = guidUtil.encodedGuid;

            $.post(url, fd)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {

                        self.setToken(this.token);
                        self.getAccountLicenseStatus().then( data => {
                            resolve(payLoad);
                        }).catch((error) => {
                            console.log(error || 'Unknown Error');
                        });
                       
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    reportSaveNew(param, groupId) {

        console.log(`groupId`, groupId);
        console.log(`reportSaveNew`, param);

        return new Promise((resolve, reject) => {

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Report/SaveNew`;
            let self = this;

            param.token = this.token;

            $.post(url, param)
                .done(data => {

                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('report save new error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    closeForm(formId) {
        const postParams = {
            token: this.getToken(),
            formId: formId,
            settingsXML: zLib.compressForm(userService.populateUserSettingsFromApp()),
            logOut: false
        };
        const url = this.apiHostUrl + '/App/Close';

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (data) {
                var response = data;
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    token = _.get(response, 'RESULT.TOKEN'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                self.setToken(token);

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });


    }

    saveView(param) {
        return new Promise((resolve, reject) => {

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/App/SaveView`;
            let self = this;

            param.token = this.token;

            $.post(url, param)
                .done(data => {

                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('saveView app error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    clearLock(id) {
        return new Promise((resolve, reject) => {
            const param = {};
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Play/ClearLock`;
            let self = this;

            param.token = this.token;
            param.linkId = id;

            $.post(url, param)
                .done(data => {

                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('clearLock error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });

    }


     getGoogleOAuth2URL() {
        return new Promise((resolve, reject) => {
            const param = {};
            let self = this;

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Integration/GoogleGetOAuth2URL`;

            param.token = this.token;

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(restMessages.codeToMessage(errorCode));
                    }

                })
                .fail(err => {
                    console.log('GoogleGetOAuth2URL connection error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    addFormFolder({ name, groupTypeId, groupParentId }) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/App/AddFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['name'] = name;
            fd['groupTypeId'] = groupTypeId;
            fd['groupParentId'] = groupParentId;

            $.post(url, fd)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    connectOAuth2(refreshToken,accessToken) {
        return new Promise((resolve, reject) => {
            const param = {};
            let self = this;

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Integration/ConnectOAuth2`;

            param.token = this.getToken();
            param.refresh_token = refreshToken;
            param.access_token = accessToken;

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject({MESSAGE: `${restMessages.codeToMessage(errorCode)}: ${message}`});
                    }
                })
                .fail(err => {
                    console.log('ConnectOAuth2 connection error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    deleteFormFolder(groupId) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/App/DeleteFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['groupId'] = groupId;

            $.ajax({
                type: 'DELETE',
                url: url,
                data: fd
            }).done(data => {
                const
                    error = _.get(data, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    message = _.get(error, 'MESSAGE', ''),
                    payLoad = _.get(data, 'RESULT.RESPONSE');

                this.token = _.get(data, 'RESULT.TOKEN');

                if (parseInt(errorCode) === 0) {
                    resolve(payLoad);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }
            })
            .fail(err => {
                reject(err);
            })
            .always(() => {
                spinner.stop();
            });
        });
    }

    unDeleteFormFolder(groupId) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/App/UndeleteFormFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['groupId'] = groupId;

            $.post(url, fd)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    unDeleteReportFolder(groupId) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/Report/UndeleteFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['groupId'] = groupId;

            $.post(url, fd)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    GetSheetsOAuth2(refreshToken,accessToken, fileId) {
        return new Promise((resolve, reject) => {
            const param = {};
            let self = this;

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Integration/GetSheetsOAuth2`;

            param.token = this.getToken();
            param.refresh_token = refreshToken;
            param.access_token = accessToken;
            param.fileId = fileId;

            $.post(url, param)
              .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    console.log('GetSheetsOAuth2 connection error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    //-------------------------------------------------------
    addReportFolder({ name, groupTypeId, groupParentId }) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/Report/AddFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['name'] = name;
            fd['groupTypeId'] = groupTypeId;
            fd['groupParentId'] = groupParentId || constants.DEFAULT_GROUP_ID;

            $.post(url, fd)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }

                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    connectAuthSub(username,password) {
        return new Promise((resolve, reject) => {
            const param = {};
            let self = this;

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Integration/Connect`;

            param.token = this.token;
            param.username = username;
            param.password = password;

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    console.log('Google AuthSub connection error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

    deleteReportFolder(groupId) {
        return new Promise((resolve, reject) => {
            const
                url = `${this.apiHostUrl}/Report/DeleteFolder`,
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                fd = {};
            let self = this;

            fd['token'] = this.getToken();
            fd['groupId'] = groupId;

            $.ajax({
                type: 'DELETE',
                url: url,
                data: fd
            }).done(data => {
                const
                error = _.get(data, 'RESULT.ERROR'),
                errorCode = _.get(error, 'CODE'),
                message = _.get(error, 'MESSAGE', ''),
                payLoad = _.get(data, 'RESULT.RESPONSE');
                this.token = _.get(data, 'RESULT.TOKEN')

                if (parseInt(errorCode) === 0) {
                    resolve(payLoad);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                }
            })
            .fail(err => {
                reject(err);
            })
            .always(() => {
                spinner.stop();
            });
        });
    }

    googleSheetColumnsOAuth2(param){
        return new Promise((resolve, reject) => {
            //const param = {};
            let self = this;

            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${this.apiHostUrl}/Integration/GoogleSheetColumnsOAuth2`;

            param.token = this.token;

            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE');

                    this.token = _.get(data, 'RESULT.TOKEN');

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        const additionalMsg = message ? ': ' + message : '';
                        reject({MESSAGE: `${restMessages.codeToMessage(errorCode)}${additionalMsg}`});
                    }

                })
                .fail(err => {
                    console.log('Get GoogleSheets Columns error: ', err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    /*====================================================================================================
     * Rest API call for retrieve the url of the SOAP web service
     * ===================================================================================================
     * */
    getWSDL(wsdlDetails) {
        return new Promise((resolve, reject) => {
            let self = this;

            let formData = new FormData();       
            formData.append('token', this.getToken());

            $.each(wsdlDetails, function (property, value) {
                formData.append(property, value || '');
            });
            const url = `${this.apiHostUrl}/Integration/GetWSDL`;

                let params = {
                    "async": true,
                    "crossDomain": true,
                    "url": url,
                    "method": "POST",
                    "headers": {
                        "cache-control": "no-cache"
                    },
                    "processData": false,
                    "contentType": false,
                    "mimeType": "multipart/form-data",
                    "data": formData
                };
                let settings = this.getSettings(params);

                let spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));

            $.ajax(settings)
                .done(data => {
                    let response = JSON.parse(data);
                    const
                        error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(response, 'RESULT.RESPONSE')["#cdata-section"];

                    self.setToken(response.RESULT.TOKEN);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        resolve(utils.minifyXMLString(payLoad));
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                    }
                })
                .fail(err => {
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });

        });
    }

    getFormDataHistory(formInstanceId) {
        return new Promise((resolve, reject) => {
            const params = {};
            const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
            const url = this.apiHostUrl + '/App/GetFormInstanceDataHistory';
            params.token = this.token;
            params.formInstanceId = formInstanceId;
            let self = this;
            $.post(url, params).done(data => {
                const response = data;
                const error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    self.setToken(response.RESULT.TOKEN);
                    resolve(response.RESULT.RESPONSE);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }
            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                spinner.stop();
            });
        });
    }


    addFavorites(param, objType) {
        return new Promise((resolve, reject) => {
                const url = `${this.apiHostUrl}/App/SetFavoriteForm`;
                const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                let self = this;

                param.token = this.token;
                param.objectType = objType;
                param.formIds = Array.isArray(param.formIds) ? param.formIds.join(',') : param.formIds;

                $.post(url, param)
                     .done(data => {
        
                        const
                            error = _.get(data, 'RESULT.ERROR'),
                            errorCode = _.get(error, 'CODE'),
                            message = _.get(error, 'MESSAGE', ''),
                            payLoad = _.get(data, 'RESULT.RESPONSE');

                            this.token = _.get(data, 'RESULT.TOKEN');

                            if (parseInt(errorCode) === 0) {
                                resolve(payLoad);
                            } else {
                                self.checkErrorCodeUserNotAuthenticated(errorCode);
                                reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                            }

                    })
                    .fail(err => {
                         console.log('adding favoriteserror: ', err);
                         reject(err);
                    })
                    .always(() => {
                        spinner.stop();
                    });
                });
    }

    removeFavorites(param, objType) {
        return new Promise((resolve, reject) => {
                const url = `${this.apiHostUrl}/App/UnsetFavoriteForm`;
                const spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
                let self = this;

                param.token = this.token;
                param.objectType = objType;

                $.post(url, param)
                     .done(data => {
        
                        const
                            error = _.get(data, 'RESULT.ERROR'),
                            errorCode = _.get(error, 'CODE'),
                            message = _.get(error, 'MESSAGE', ''),
                            payLoad = _.get(data, 'RESULT.RESPONSE');

                            this.token = _.get(data, 'RESULT.TOKEN');

                            if (parseInt(errorCode) === 0) {
                                resolve(payLoad);
                            } else {
                                self.checkErrorCodeUserNotAuthenticated(errorCode);
                                reject(`${restMessages.codeToMessage(errorCode)}: ${message}`);
                            }

                    })
                    .fail(err => {
                         console.log('removing favorites error: ', err);
                         reject(err);
                    })
                    .always(() => {
                        spinner.stop();
                    });
                });
    }

     /*======================================================================
     * Rest API call for synchronize Users with a directory service.
     * ======================================================================
     * */
    runUsersSynchronization(showSpinner = null) {
        const postParams = {
            'token':this.getToken()
        };
        const url = this.apiHostUrl + '/user/RunUsersSynchronization';
        let spinner;
        if (showSpinner){
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        }

        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');
                self.setToken(response.RESULT.TOKEN);
                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                if (showSpinner){
                    spinner.stop();
                }
            });
        });

        return promise;

    }

    /*======================================================================
     * Rest API call for commit the synchronization with a directory service.
     * ======================================================================
     * */
    commitUsersSynchronization(synchronizationXML,showSpinner = null) {
        const postParams = {
            'token':this.getToken(),
            synchronizationXML
        };
        const url = this.apiHostUrl + '/user/CommitUsersSynchronization';
        let spinner;
        if (showSpinner){
            spinner = new Spinner().spin($(constants.CONTENT_ID).get(0));
        }

        return new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                let error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            }).always(() => {
                if (showSpinner) {
                    spinner.stop();
                }
            });
        });

    }

    /*==============================================================================
     * Rest API call for deleting instance of a form
     * =============================================================================
     * */
    deleteFormInstance(formInstancesXML) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'DELETE',
                url: this.apiHostUrl + '/App/DeleteInstance',
                data: {token: this.getToken(), formInstancesXML: formInstancesXML},
                success: function (data) {
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App draft instances successfully deleted');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    /*==============================================================================
     * Rest API call for restoring instance of a form
     * =============================================================================
     * */
    unDeleteFormInstance(formInstancesXML) {
        return new Promise((resolve, reject) => {
            let self = this;
            $.ajax({
                type: 'POST',
                url: this.apiHostUrl + '/App/unDeleteInstance',
                data: {token: this.getToken(), formInstancesXML: formInstancesXML},
                success: function (data) {
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve(serverResponse || 'App instances successfully restored');
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    /* ==============================================================================
     * Rest API call for updating a form folder name
     * =============================================================================
    */
    renameFolder({ idFolder, newName, isForm }) {
        return new Promise((resolve, reject) => {
            let self = this;
            const params = {
                token: this.getToken(),
                groupId: idFolder,
                name: newName || 'New Folder'
            };
            const url = this.apiHostUrl + ( isForm ? '/App/RenameFolder' : '/Report/RenameFolder' );

            $.ajax({
                type: 'POST',
                url: url,
                data: params,
                success: function (data) {
                    var response = data;
                    var error = _.get(response, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        errorMessage = _.get(error, 'MESSAGE'),
                        serverResponse = _.get(response, 'RESULT.RESPONSE'),
                        token = _.get(response, 'RESULT.TOKEN');
                    if (parseInt(errorCode) === 0) {
                        resolve({msg:`Folder renamed to "${params.name}"`});
                        self.setToken(token);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject(error);
                    }
                },
                error: function (error) {
                    reject(error);
                }
            });
        });
    }

    resetPassword(newPassword){
        const postParams = {
            token: this.getToken(),
            password: newPassword
        };
        const url = this.apiHostUrl + '/Login/ChangePassword';
        let promise = new Promise((resolve, reject) => {
            let self = this;
            $.post(url, postParams).done(function (response) {
                var error = _.get(response, 'RESULT.ERROR'),
                    errorCode = _.get(error, 'CODE'),
                    serverResponse = _.get(response, 'RESULT.RESPONSE');

                if (parseInt(errorCode) === 0 && serverResponse !== undefined) {
                    resolve(response);
                    self.setToken(response.RESULT.TOKEN);
                } else {
                    self.checkErrorCodeUserNotAuthenticated(errorCode);
                    reject(error);
                }

            }).fail(function (jqXHR, textStatus, errorThrown) {
                reject(errorThrown);
            });
        });
        return promise;
    }

    checkErrorCodeUserNotAuthenticated(errorCode){
        if (errorCode && parseInt(errorCode) === 2){
            utils.isLoggedIn = false;
            undoService.clear();
        }
    }

    /*====================================================================================================
     * Rest API call to retrieve the account license status
     * ===================================================================================================
     * */
   
    getAccountLicenseStatus() {
        const self = this;

        return new Promise((resolve, reject) => {
            const param = {};
       
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${self.apiHostUrl}/Account/AccountLicenseStatus`;

            param.token = self.getToken();
         
            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE'),
                        token = _.get(data, 'RESULT.TOKEN');
                    
                    self.setToken(token);

                    if (parseInt(errorCode) === 0 && payLoad) {
                        listService.accountSettings.license = payLoad
                        eventBus.trigger(constants.EV_LOAD_TRIAL_STATUS);
                        resolve(payLoad);
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject({MESSAGE: `${restMessages.codeToMessage(errorCode)}: ${message}`});
                    }
                })
                .fail(err => {
                    console.log(err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

     /*====================================================================================================
     * Rest API call to send email to sales to request a quote
     * ===================================================================================================
     * */
   
    sendQuoteRequest() {
        const self = this;

        return new Promise((resolve, reject) => {
            const param = {};
       
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${self.apiHostUrl}/Account/TrialAccountGetQuote`;

            param.token = self.getToken();
         
            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE'),
                        token = _.get(data, 'RESULT.TOKEN');
                    
                    self.setToken(token);

                    if (parseInt(errorCode) === 0) {
                        resolve("OK");
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject({MESSAGE: `${restMessages.codeToMessage(errorCode)}: ${message}`});
                    }
                })
                .fail(err => {
                    console.log(err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

     /*====================================================================================================
     * Rest API call to send email with app link after tours
     * ===================================================================================================
     * */   
     shareAppLinkByEmail(params) {
        const self = this;

        return new Promise((resolve, reject) => {
            const param = {};
       
            const
                spinner = new Spinner().spin($(constants.CONTENT_ID).get(0)),
                url = `${self.apiHostUrl}/app/ShareAppLinkByEmail`;

            param.token = self.getToken();
            param.formId = params.formId;
            param.emailAddressList = params.emails;
            param.body = params.message;
         
            $.post(url, param)
                .done(data => {
                    const
                        error = _.get(data, 'RESULT.ERROR'),
                        errorCode = _.get(error, 'CODE'),
                        message = _.get(error, 'MESSAGE', ''),
                        payLoad = _.get(data, 'RESULT.RESPONSE'),
                        token = _.get(data, 'RESULT.TOKEN');
                    
                    self.setToken(token);

                    if (parseInt(errorCode) === 0) {
                        resolve("OK");
                    } else {
                        self.checkErrorCodeUserNotAuthenticated(errorCode);
                        reject({MESSAGE: `${restMessages.codeToMessage(errorCode)}: ${message}`});
                    }
                })
                .fail(err => {
                    console.log(err);
                    reject(err);
                })
                .always(() => {
                    spinner.stop();
                });
        });
    }

}

const restService = new RestService();
export default restService;
